var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        function getMinAvailableDate() {
            // Календарь рисуем от текущей даты + 1 день
            var date = new Date();
            date.setDate(date.getDate() + 1);
            date.setHours(0, 0, 0, 0);

            return date;
        }

        function getCalendarRenderDateBounds() {
            // Количество месяцев для вывода
            var renderMonths = 12;
            var minDate = getMinAvailableDate();
            // + renderMonths месяцев. В maxDate последний день месяца maxDate
            var maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + renderMonths + 1, 0);

            return { minDate: minDate, maxDate: maxDate };
        }

        /**
         * @param {jQuery} wrapper
         * @param {Date} value
         * @param {{
         *  onChanged: Function,
         *  dateFormat: string,
         *  messages: { months: Array<string>, dayNames: Array<string> }
         * }} params
         * @constructor
         */
        function Calendar(wrapper, value, params) {
            this.wrapper = wrapper;
            this.onChanged = params.onChanged;
            this.dateFormat = params.dateFormat;
            // Сегодня
            this.setValue(value);
            this.startDate = getMinAvailableDate();
            // Границы отрисовки календаря
            this.renderBounds = getCalendarRenderDateBounds();

            // Месяцы календаря
            // название месяца, вместо цифр 0-11
            this.month = params.messages.months || ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
            this.weekDays = params.messages.dayNames || ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];

            this.isManualChangedDate = false;
            this.elems = {
                items: this.wrapper.find('.months'),
                leftArrow: this.wrapper.find('button.left'),
                rightArrow: this.wrapper.find('button.right')
            };
            this.w_element = 275;
            this.delta = 46;
            this.availableDates = [];

            this.createHandlers();
        }

        Calendar.prototype.setAvailableDates = function (dates) {
            this.availableDates = dates;
            this.render();
        };

        /**
         * @param value Date
         */
        Calendar.prototype.setValue = function (value) {
            this.date = value;
            this.curDate = this.makeDate(value);
        };

        Calendar.prototype.setWidth = function () {
            this.w = this.wrapper.find('.wrapper').width();
            this.minX = -this.elems.items.find('.month').length * this.w_element + this.w + this.delta;
        };

        Calendar.prototype.createHandlers = function () {
            var self = this;
            this.wrapper.on('click', '.date', function () {
                $('.active', self.wrapper).removeClass('active');
                $(this).addClass('active');
                var date = moment($(this).data('date'), self.dateFormat);
                self.setValue(date.toDate());
                self.isManualChangedDate = true;
                self.onChanged(self.curDate, self.isManualChangedDate);
            });
            this.wrapper.on('click', '.controls button', function () {
                var direction = $(this).hasClass('right') ? 1 : -1;
                var currentMarginLeft = Math.abs(parseFloat(self.elems.items.css('margin-left')));
                var t = currentMarginLeft / self.w_element;
                var currentMonthIndex = Math.ceil(t);
                if (direction === -1) {
                    currentMonthIndex = Math.floor(t);
                }
                if (t === currentMonthIndex) {
                    currentMonthIndex += direction;
                }

                self.scrollToMonth(currentMonthIndex, true);
            });
        };

        /**
         * Проверяет входит ли дата в заданный диапазон ограничений
         * Если ограничения не заданы - вернет true
         * @param {Date} date
         */
        Calendar.prototype.isDateInRange = function (date) {
            var range = this.renderBounds;
            return !(range.minDate && range.minDate.getTime() > date.getTime() || range.maxDate && range.maxDate.getTime() < date.getTime());
        };

        /**
         * Выделение диапазона
         * @param {Date} startDate - начать выделение с указанной даты
         * @param {int} rangeCellsCount - кол-во ячеек для выделения
         */
        Calendar.prototype.markRange = function (startDate, rangeCellsCount) {
            var DATE_IN_RAGE = 'date-in-range';
            var DATE_IN_RAGE_START = 'date-in-range-start';
            var DATE_IN_RAGE_END = 'date-in-range-end';
            this.wrapper.find('.' + DATE_IN_RAGE).removeClass(DATE_IN_RAGE + ' ' + DATE_IN_RAGE_START + ' ' + DATE_IN_RAGE_END);
            if (rangeCellsCount > 1) {
                for (var i = 0; i < rangeCellsCount; i++) {
                    var cssClass = DATE_IN_RAGE;
                    if (i === 0) {
                        cssClass += ' ' + DATE_IN_RAGE_START;
                    } else if (i === rangeCellsCount - 1) {
                        cssClass += ' ' + DATE_IN_RAGE_END;
                    }
                    if (this.isDateInRange(startDate)) {
                        this.$getCell(startDate).not('.old').addClass(cssClass);
                    }
                    startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1);
                }
            } else {
                this.$getCell(startDate).not('.old').addClass(DATE_IN_RAGE + ' ' + DATE_IN_RAGE_START + ' ' + DATE_IN_RAGE_END);
            }
        };

        /**
         * Получить jQuery объект ссылку на ячейку даты
         * @param {Date} date
         * @return {jQuery}
         */
        Calendar.prototype.$getCell = function (date) {
            return this.wrapper.find('td[data-date="' + this.makeDate(date) + '"]');
        };

        /**
         *
         * @param {number} monthIndex
         * @param {boolean} animate
         */
        Calendar.prototype.scrollToMonth = function (monthIndex, animate) {
            var newX = -1 * this.w_element * monthIndex;
            if (newX > 0) {
                this.elems.leftArrow.addClass('arr_offers__disabled');
                this.elems.rightArrow.removeClass('arr_offers__disabled');
            } else if (this.minX > newX) {
                this.elems.rightArrow.addClass('arr_offers__disabled');
                this.elems.leftArrow.removeClass('arr_offers__disabled');
            }

            newX = newX > 1 ? 0 : newX < this.minX ? this.minX : newX;

            if (this.minX > newX) {
                newX = this.minX;
            }

            var $items = this.elems.items;
            if (animate) {
                $items.animate({ marginLeft: newX + 'px' });
            } else {
                $items.css('margin-left', newX + 'px');
            }
        };

        /**
         * Пока считаем
         */
        Calendar.prototype.scrollToSelectedDateMonth = function () {
            var minDate = this.renderBounds.minDate;
            var maxDate = this.renderBounds.maxDate;

            var $currentMonth = this.elems.items.find('.month[data-month="' + this.makeMonth(this.date) + '"]');
            if ($currentMonth.length === 0) {
                return;
            }

            // Рассчитано на работу только при 2 месяцах во viewPort
            var currentMonthRenderIndex = parseInt($currentMonth.data('index'), 10);
            if (this.isSameMonth(this.date, maxDate) && !this.isSameMonth(this.date, minDate)) {
                // Выбранная дата в последнем (максимальном) отрисованном месяце
                // И до этой даты есть еще минимум 1 месяц
                currentMonthRenderIndex -= 1;
            }

            this.scrollToMonth(currentMonthRenderIndex, false);
        };

        /**
         * @param {Date} date1
         * @param {Date} date2
         * @return {boolean}
         */
        Calendar.prototype.isSameMonth = function (date1, date2) {
            return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
        };

        /**
         * @param {Date} date
         * @return {string}
         */
        Calendar.prototype.makeMonth = function (date) {
            return date.getFullYear() + '.' + (date.getMonth() + 1);
        };

        Calendar.prototype.makeDate = function (D2) {
            var day, m;
            day = D2.getDate();
            day = ('0' + day).slice(-2);
            m = D2.getMonth() + 1;
            m = ('0' + m).slice(-2);

            return [day, m, D2.getFullYear()].join('.');
        };

        Calendar.prototype.render = function () {
            var minDate = this.renderBounds.minDate;
            var maxDate = this.renderBounds.maxDate;
            // Отрисовать календарь до указанного месяца, исключая renderTillMonth
            var renderTillMonth = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 1);

            var renderFromMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
            var calendarHtml = '';
            var renderIndex = 0;
            do {
                calendarHtml += this.renderMonth(renderFromMonth.getMonth(), renderFromMonth.getFullYear(), renderIndex);
                renderIndex++;
                renderFromMonth = new Date(renderFromMonth.getFullYear(), renderFromMonth.getMonth() + 1, 1);
            } while (!this.isSameMonth(renderFromMonth, renderTillMonth));

            this.elems.items.html(calendarHtml);
            this.setWidth();
            this.scrollToSelectedDateMonth();
        };

        /**
         * @param {number} month
         * @param {number} fullYear
         * @param {number} renderIndex
         * @return {string}
         */
        Calendar.prototype.renderMonth = function (month, fullYear, renderIndex) {
            var calendarTbl = '';

            var baseDate = new Date(fullYear, month, 1);

            // Последний день месяца (Date)
            var lastDateOfCurrentMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
            // последний день месяца
            var D1last = lastDateOfCurrentMonth.getDate();
            // день недели последнего дня месяца
            var D1Nlast = new Date(baseDate.getFullYear(), baseDate.getMonth(), D1last).getDay();
            // день недели первого дня месяца
            var D1Nfirst = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1).getDay();
            // Последний день предыдущего месяца
            var D1lastPrev = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0).getDate();

            var emptyDate = void 0;
            var classList = void 0;
            var dataDate = void 0;
            var D2 = void 0;

            calendarTbl += '<div class="month"' + ' data-month="' + this.makeMonth(baseDate) + '"' + ' data-index="' + renderIndex + '">';
            calendarTbl += '<span class="month-name">' + this.month[baseDate.getMonth()] + ' ' + baseDate.getFullYear() + '</span>';
            calendarTbl += '<table>';
            calendarTbl += '<tr class="week-days">\
        <td>' + this.weekDays[1] + '</td>\
        <td>' + this.weekDays[2] + '</td>\
        <td>' + this.weekDays[3] + '</td>\
        <td>' + this.weekDays[4] + '</td>\
        <td>' + this.weekDays[5] + '</td>\
        <td class="output">' + this.weekDays[6] + '</td>\
        <td class="output">' + this.weekDays[0] + '</td>\
    </tr>';
            calendarTbl += '<tr>';

            // пустые клетки до первого дня текущего месяца
            var i = void 0;

            if (D1Nfirst !== 0) {
                for (i = 1; i < D1Nfirst; i++) {
                    emptyDate = D1lastPrev - D1Nfirst + i + 1;
                    calendarTbl += '<td class="old unavailable_date">' + emptyDate + '</td>';
                }
            } else {
                // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
                for (i = 0; i < 6; i++) {
                    emptyDate = D1lastPrev - 5 + i;
                    calendarTbl += '<td class="old unavailable_date">' + emptyDate + '</td>';
                }
            }

            // дни месяца
            for (i = 1; i <= D1last; i++) {
                classList = 'date';
                D2 = new Date(baseDate.getFullYear(), baseDate.getMonth(), i);
                if (D2.getMonth() === this.date.getMonth() && D2.getDate() === this.date.getDate()) {
                    classList += ' active';
                }

                if (!this.isDateAvailable(D2)) {
                    classList += ' unavailable_date';
                }

                dataDate = this.makeDate(D2);
                calendarTbl += '<td class="' + classList + '" data-date="' + dataDate + '">' + i + '</td>';
                // если день выпадает на воскресенье, то перевод строки
                if (new Date(baseDate.getFullYear(), baseDate.getMonth(), i).getDay() === 0) {
                    calendarTbl += '</tr><tr>';
                }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast !== 0) {
                for (i = D1Nlast; i < 7; i++) {
                    emptyDate = i - D1Nlast + 1;
                    D2 = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, emptyDate);
                    dataDate = this.makeDate(D2);
                    calendarTbl += '<td class="old date unavailable_date" data-date="' + dataDate + '">' + emptyDate + '</td>';
                }
            }

            calendarTbl += '</tr>';

            calendarTbl += '</table>';
            calendarTbl += '</div>';

            return calendarTbl;
        };

        /**
         * @param {Date} date
         */
        Calendar.prototype.isDateAvailable = function (date) {
            var isAvailableDate = true;
            var dataDate = this.makeDate(date);
            if (this.availableDates.length && this.availableDates.indexOf(dataDate) === -1) {
                isAvailableDate = false;
            } else if (this.renderBounds.minDate.getTime() > date.getTime()) {
                isAvailableDate = false;
            }

            return isAvailableDate;
        };

        module.exports = Calendar;
    }, {}], 2: [function (require, module, exports) {
        var Calendar = require('../../../../include/calendar/_js/Calendar');

        var DateSelect = function () {
            /**
             * @param $dropdown
             * @param {{
             *  onChange: function,
             *  onAfterShow: function,
             *  values: SearchFormValues,
             *  rangeDays: int,
             *  MOMENT_DATE_FORMAT: string,
             *  allMessages: FindFormJsMessages,
             * }} params
             */
            function DateSelect($dropdown, params) {
                _classCallCheck(this, DateSelect);

                this.$dropdown = $dropdown;

                this.rangeDays = params.rangeDays;

                this.onChange = params.onChange;

                this.onAfterShow = params.onAfterShow;

                this.MOMENT_DATE_FORMAT = params.MOMENT_DATE_FORMAT;

                /**
                 * @type {{softDates: boolean, selectedDate: Date}}
                 */
                this.values = {
                    softDates: params.values.isSoftDates,
                    selectedDate: params.values.selectedDate
                };
                this.init(params.allMessages);
            }

            /**
             * @param {FindFormJsMessages} allMessages
             */


            _createClass(DateSelect, [{
                key: "init",
                value: function init(allMessages) {
                    var _this = this;

                    // выставляем значение softDays
                    this.$dropdown.find('.days input').prop('checked', this.values.softDates);

                    /**
                     * @type {Calendar}
                     */
                    this.calendar = new Calendar(this.$dropdown.find('.calendar'), this.values.selectedDate, {
                        onChanged: function onChanged(date, isHumanChange) {
                            _this.values.selectedDate = moment(date, _this.MOMENT_DATE_FORMAT).toDate();
                            _this.dispatchOnChange(isHumanChange);
                            _this.hide();
                            _this.markSelectedRange();
                        },
                        dateFormat: this.MOMENT_DATE_FORMAT,
                        messages: allMessages.calendar
                    });
                    this.calendar.render();

                    this.attachHandlers();
                }
            }, {
                key: "attachHandlers",
                value: function attachHandlers() {
                    var _this2 = this;

                    $('input', this.$dropdown).on('change', function (event) {
                        _this2.values.softDates = !!$(event.currentTarget).prop('checked');
                        // на текущий момент отметка о выборе даты пользователем ставится только при click на дату
                        // одна из причин: при изменении softDates не нужно открывать следующий блок
                        _this2.dispatchOnChange(false);
                        _this2.markSelectedRange();
                    });
                }

                /**
                 * @param {Date} date
                 */

            }, {
                key: "setDate",
                value: function setDate(date) {
                    this.values.selectedDate = date;
                    this.calendar.setValue(date);
                }

                /**
                 * @param {Array} dates
                 */

            }, {
                key: "setAvailableDates",
                value: function setAvailableDates(dates) {
                    this.calendar.setAvailableDates(dates);
                    this.markSelectedRange();
                }
            }, {
                key: "isOpenedNow",
                value: function isOpenedNow() {
                    return this.$dropdown.hasClass('open');
                }
            }, {
                key: "show",
                value: function show() {
                    this.$dropdown.addClass('open');
                    this.onAfterShow();
                }
            }, {
                key: "hide",
                value: function hide() {
                    this.$dropdown.removeClass('open');
                }
            }, {
                key: "updateLabel",
                value: function updateLabel(text) {
                    this.$dropdown.find('.date_field').html(text);
                }
            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange(isHumanChange) {
                    this.onChange(isHumanChange);
                }

                /**
                 * @private
                 */

            }, {
                key: "markSelectedRange",
                value: function markSelectedRange() {
                    var selectedDate = this.values.selectedDate;
                    var isRange = this.values.softDates;
                    var rangeCellsCount = isRange ? this.rangeDays + 1 : 1;
                    this.calendar.markRange(selectedDate, rangeCellsCount);
                }
            }]);

            return DateSelect;
        }();

        window.findFormComponents = window.findFormComponents || {};
        window.findFormComponents.DateSelect = DateSelect;
    }, { "../../../../include/calendar/_js/Calendar": 1 }] }, {}, [2]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * Страны/регионы/отели в 1 поле
         * @type {string}
         */
        var MODE_ALL = 'all';

        /**
         * Страны/регионы и отели в разных полях
         * @type {string}
         */
        var MODE_COUNTRY_REGION = 'country-region';

        /**
         * Только отели
         * @type {string}
         */
        var MODE_ONLY_HOTELS = 'only-hotels';

        var REGION_ID_ALL = 0;

        var TYPE_COUNTRY = 'country';

        var TYPE_REGION = 'region';

        var TYPE_HOTEL = 'hotel';

        var INPUT_RADIO = 'radio';
        var INPUT_CHECKBOX = 'checkbox';

        var i18nPlural = window.utils.i18n.plural;
        var i18nTemplate = window.utils.i18n.template;

        var DestinationSelectHotel =
        /**
         * @param {{
         *   id: number,
         *   name: string,
         *   countryId: number
         * }} props
         */
        function DestinationSelectHotel(props) {
            _classCallCheck(this, DestinationSelectHotel);

            this.id = props.id;
            this.name = props.name;
            this.countryId = props.countryId;
        };

        /**
         * Локальное состояние формы
         * Состояние формы актуально только пока она видима (Состояние на момент последнего открытия).
         * (при определнных сценариях:
         *   - изменении города/отеля/страны,
         *   - сбросе значений
         *   состояние может отличаться)
         */


        var DestinationSelectValues = function () {
            /**
             * @param {SearchFormValues} values
             */
            function DestinationSelectValues(values) {
                _classCallCheck(this, DestinationSelectValues);

                /** @type {number} */
                this.departCityId = 0;
                /** @type {number} */
                this.countryId = 0;
                /** @type {number[]} */
                this.regionIds = [];
                /** @type {DestinationSelectHotel|null} */
                this.selectedHotel = null;

                this.set(values);
            }

            _createClass(DestinationSelectValues, [{
                key: "reset",
                value: function reset() {
                    this.countryId = 0;
                    this.regionIds = [];
                    this.resetHotel();
                }
            }, {
                key: "resetHotel",
                value: function resetHotel() {
                    this.selectedHotel = null;
                }

                /**
                 * @param {SearchFormValues} values
                 */

            }, {
                key: "set",
                value: function set(values) {
                    this.reset();
                    this.departCityId = values.departCityId;
                    this.countryId = values.countryId;
                    this.regionIds = values.regionIds;
                    if (values.selectedHotel) {
                        var selectedHotel = values.selectedHotel;
                        this.selectedHotel = new DestinationSelectHotel({
                            id: selectedHotel.id,
                            name: selectedHotel.name,
                            countryId: selectedHotel.countryId
                        });
                    }
                }

                /**
                 * Выбран ли указанный регион
                 * @param {number|string} regionId
                 * @param {number|string} departCityId
                 * @return {boolean}
                 */

            }, {
                key: "isRegionSelected",
                value: function isRegionSelected(regionId, departCityId) {
                    regionId = Number(regionId);
                    if (regionId === REGION_ID_ALL) {
                        return this.regionIds.length === 0;
                    }

                    return this.regionIds.indexOf(regionId) !== -1 && this.departCityId === Number(departCityId);
                }

                /**
                 * @param {number[]} regionIds
                 */

            }, {
                key: "setSelectedRegionIds",
                value: function setSelectedRegionIds(regionIds) {
                    this.regionIds = regionIds;
                }

                /**
                 * @param {number|string} regionId
                 * @param {number|string} departCityId
                 */

            }, {
                key: "addSelectedRegionId",
                value: function addSelectedRegionId(regionId, departCityId) {
                    if (!this.isRegionSelected(regionId, departCityId)) {
                        this.regionIds.push(Number(regionId));
                    }
                }

                /**
                 * @param {number} regionId
                 */

            }, {
                key: "removeSelectedRegionValue",
                value: function removeSelectedRegionValue(regionId) {
                    var index = this.regionIds.indexOf(regionId);
                    if (index !== -1) {
                        this.regionIds.splice(index, 1);
                    }
                }
            }]);

            return DestinationSelectValues;
        }();

        var DestinationSelect = function () {
            /**
             * @param {jQuery} $dropdown
             * @param {SearchFormData} formData
             * @param {{
             *  values: SearchFormValues,
             *  messages: FindFormJsMessages,
             *  onChange: function,
             *  onOpenNext: function,
             *  mode: string
             * }} params
             */
            function DestinationSelect($dropdown, formData, params) {
                _classCallCheck(this, DestinationSelect);

                /**
                 * @type {jQuery}
                 */
                this.$dropdown = $dropdown;
                /**
                 * @type {SearchFormData}
                 */
                this.data = formData;
                /**
                 * @type {Function}
                 */
                this.onChange = params.onChange;
                /**
                 * @type {Function}
                 */
                this.onOpenNext = params.onOpenNext || null;
                /**
                 * @type {string}
                 */
                this.mode = params.mode;

                /**
                 * @type {{$input: {jQuery}, $title: {jQuery}}}
                 */
                this.elements = {
                    $input: this.$dropdown.find('.direction_field'),
                    $title: this.$dropdown.find('.form-title')
                };

                /**
                 * Можно ли искать отели в рамках текущего dropdown
                 * MODE_ALL, MODE_ONLY_HOTELS
                 * @type {boolean}
                 */
                this.isHotelsSearchEnabled = this.mode !== MODE_COUNTRY_REGION;

                /**
                 * Можно ли искать страны/регионы в рамках текущего dropdown
                 * MODE_ALL, MODE_COUNTRY_REGION
                 * @type {boolean}
                 */
                this.isDestinationSearchEnabled = this.mode !== MODE_ONLY_HOTELS;

                /**
                 * На текущий момент идет поиск
                 * @type {boolean}
                 */
                this.isAutocompleteSearch = false;

                /**
                 * @type {null|{success: boolean, query: string, result: {}}}
                 */
                this.lastResponseCache = null;

                /**
                 * Минимально кол-во символов для поиска по отелю
                 * @type {number}
                 */
                this.hotelSearchMinLength = 3;

                /**
                 * Задержка для поиска по списку стран/отелей/регионов
                 * @type {number}
                 */
                this.debounceInputTime = 300;

                /**
                 * Последний запрос в автокомплите
                 * @type {string}
                 */
                this.autocompleteLastSlug = '';

                this.timers = {
                    /**
                     * @type {null|number}
                     */
                    input: null
                };

                this._values = new DestinationSelectValues(params.values);
                this.allMessages = params.messages;

                this.attachHandlers();
            }

            _createClass(DestinationSelect, [{
                key: "attachHandlers",
                value: function attachHandlers() {
                    var _this3 = this;

                    this.$dropdown.on('click', '.destination-item', function (event) {
                        var $button = $(event.currentTarget);

                        var data = $button.data();
                        var cityID = parseInt(data.city, 10);
                        var countryID = parseInt(data.country, 10);
                        var itemId = parseInt(data.value, 10);

                        var isCheckbox = $button.prop('type') === INPUT_CHECKBOX;
                        var isChecked = $button.prop('checked');

                        if (isCheckbox && data.type === TYPE_REGION && itemId === REGION_ID_ALL && !isChecked) {
                            // запрет на uncheck "Все курорты"
                            event.preventDefault();
                            return;
                        }

                        var allowCloseOnSelect = true;
                        var allowExternalReRender = true;

                        var isCountryChanged = data.type === TYPE_COUNTRY && _this3._values.countryId !== countryID;

                        var selectedRegionIds = _this3._values.regionIds;
                        _this3._values.reset();
                        _this3._values.departCityId = cityID;
                        _this3._values.countryId = countryID;
                        switch (data.type) {
                            case TYPE_REGION:
                                if (isCheckbox) {
                                    // Возвращаем регионы, выбранные до сброса
                                    _this3._values.setSelectedRegionIds(selectedRegionIds);
                                    _this3.onRegionCheckboxChange($button);
                                    allowCloseOnSelect = false;
                                    allowExternalReRender = false;
                                } else {
                                    var values = itemId === REGION_ID_ALL ? [] : [itemId];
                                    _this3._values.setSelectedRegionIds(values);
                                }
                                break;
                            case TYPE_HOTEL:
                                _this3._values.selectedHotel = {
                                    id: itemId,
                                    name: $button.next('label').text().trim(),
                                    countryId: _this3._values.countryId
                                };
                                _this3._values.selectedHotel = new DestinationSelectHotel({
                                    id: itemId,
                                    name: $button.next('label').text().trim(),
                                    countryId: _this3._values.countryId
                                });
                                break;
                            case TYPE_COUNTRY:
                                break;
                        }

                        var closeOnSelect = false;
                        if (_this3.mode === MODE_ONLY_HOTELS) {
                            // Клик по отелю
                            closeOnSelect = !!_this3._values.selectedHotel;
                        } else {
                            // Закрытие при клике по региону или отелю или по активной стране
                            closeOnSelect = data.type !== TYPE_COUNTRY || !isCountryChanged;
                        }
                        closeOnSelect = allowCloseOnSelect && closeOnSelect;

                        var isHumanChange = true;
                        if (closeOnSelect) {
                            _this3.hide();
                        }
                        _this3.dispatchOnChange(isHumanChange, allowExternalReRender);

                        // При закрытии модалки, после выбора - перейти к показу следующего окна
                        if (closeOnSelect && isHumanChange) {
                            _this3.onOpenNext();
                        }
                    });

                    this.$dropdown.on('click', '.remove', function () {
                        _this3.resetSelection(true);
                    });

                    this.elements.$input.on('keyup', function () {
                        _this3._onDestinationEnter(false);
                    });
                }

                /**
                 * @return {boolean}
                 */

            }, {
                key: "isOpenedNow",
                value: function isOpenedNow() {
                    return this.$dropdown.hasClass('open');
                }

                /**
                 * @param {SearchFormValues} values
                 */

            }, {
                key: "setValues",
                value: function setValues(values) {
                    this._values.set(values);
                }

                /**
                 * @param {number} id
                 */

            }, {
                key: "setDepartCityId",
                value: function setDepartCityId(id) {
                    this._values.departCityId = id;
                }

                /**
                 * @return {DestinationSelectValues}
                 */

            }, {
                key: "getValues",
                value: function getValues() {
                    return this._values;
                }

                /**
                 * @param {SearchFormValues} values
                 */

            }, {
                key: "show",
                value: function show(values) {
                    // Устанавливаем текущее состояние формы
                    this.setValues(values);
                    // Отрисовать контент
                    this.renderDestinationDropDown();
                    // Показать модалку
                    this.$dropdown.addClass('open');

                    var $elem = this.elements.$input;
                    var $preloader = this.$dropdown.find('.preloader');

                    if ($elem.val() === '') {
                        $elem.attr('placeholder', '');
                        $preloader.removeClass('hidden');
                        setTimeout(function () {
                            $preloader.addClass('hidden');
                            $elem.attr('placeholder', $elem.data('hotel-placeholder')).focus();
                        }, 500);
                    }
                }
            }, {
                key: "hide",
                value: function hide() {
                    this.$dropdown.removeClass('open');

                    var $elem = this.elements.$input;
                    $elem.attr('placeholder', $elem.data('preview'));

                    this.renderFace();
                    if (this.mode === MODE_ONLY_HOTELS) {
                        if (!this._values.selectedHotel) {
                            this._hideDestinationResetButton();
                        }
                    } else if (!this._values.countryId) {
                        this._hideDestinationResetButton();
                    }
                }
            }, {
                key: "renderFace",
                value: function renderFace() {
                    var allowShowResetButton = true;
                    // В режиме "только отели"
                    if (this.mode === MODE_ONLY_HOTELS && !this._values.selectedHotel) {
                        allowShowResetButton = false;
                    } else if (!this._values.countryId) {
                        allowShowResetButton = false;
                    }

                    this.elements.$input.val(this.getLabel());

                    if (allowShowResetButton) {
                        this._showDestinationResetButton();
                    } else {
                        this._hideDestinationResetButton();
                    }
                }

                /**
                 * @param {boolean} allRegionNames
                 * @return {string}
                 */

            }, {
                key: "getLabel",
                value: function getLabel() {
                    var allRegionNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    var destination = '';
                    var values = this._values;
                    if (this.mode === MODE_ONLY_HOTELS || this.isHotelsSearchEnabled && values.selectedHotel) {
                        // В режиме "Только отели" или (разрешен поиск по отелям и выбраны отели)
                        // В этом режиме выводится только выбранный отель
                        if (values.selectedHotel) {
                            destination = values.selectedHotel.name;
                        }
                    } else if (values.regionIds.length) {
                        var countryName = this.data.getCountry(values.countryId).name;
                        var regionsCount = values.regionIds.length;

                        if (allRegionNames) {
                            destination = countryName + ' (' + this.data.getRegionNames(values.countryId, values.regionIds) + ')';
                        } else if (regionsCount === 1) {
                            destination = this.data.getRegionName(values.countryId, values.regionIds[0]) + ', ' + countryName;
                        } else {
                            destination += regionsCount + ' ' + i18nPlural(regionsCount, this.allMessages.pluralResorts) + ', ' + countryName;
                        }
                    } else if (values.countryId) {
                        destination = this.data.getCountry(values.countryId).name;
                    }

                    return destination;
                }
            }, {
                key: "_showDestinationResetButton",
                value: function _showDestinationResetButton() {
                    this.$dropdown.find('.remove').removeClass('hidden');
                }
            }, {
                key: "_hideDestinationResetButton",
                value: function _hideDestinationResetButton() {
                    this.$dropdown.find('.remove').addClass('hidden');
                }

                // ------------------------------------------------------------------------------ RENDER DESTINATION DROPDOWN START
                /**
                 * Отрисовка контента dropdown
                 */

            }, {
                key: "renderDestinationDropDown",
                value: function renderDestinationDropDown() {
                    if (!this._beforeRenderDestinationDropDown()) {
                        return;
                    }

                    var html = '';
                    var scrollTop = false;

                    if (this.mode === MODE_ONLY_HOTELS) {
                        html = this._getCurrentDestinationHtml();
                        // Если на текущий момент ничего не выбрано и в поле автокомплита ничего не введено
                        if (html === '' && !this.isAutocompleteSearch) {
                            html = this._getVariantsHint(this._getHotelSearchLengthMessage());
                        }
                    } else {
                        // если не выбран отель
                        // так как если выбран отель то в выпадашке должен быть только 1 элемент,
                        // который отрисуется через this.getCurrentDestinationHtml
                        if (this.isHotelsSearchEnabled && this._values.selectedHotel) {
                            // Текущий выбранный отель
                            html = this._getCurrentDestinationHtml();
                        } else if (this._values.countryId) {
                            html = this._getRegionsListHtml();
                            // Переключение экранов "страны => регионы"
                            scrollTop = true;
                        } else {
                            // При отрисовке общего списка стран
                            html = this._getCountriesListHtml();
                        }
                    }

                    var $countriesWrapper = this.$variantsWrapper;
                    if (scrollTop) {
                        // При выборе страны не из 1ого экрана - скролл вверх
                        $countriesWrapper.scrollTop(0);
                    }
                    $countriesWrapper.html(html);
                    this._afterRenderDestinationDropDown();
                }

                /**
                 * @return {boolean}
                 */

            }, {
                key: "_beforeRenderDestinationDropDown",
                value: function _beforeRenderDestinationDropDown() {
                    // скрываем все дивы
                    this.$dropdown.find('.direction_dropdown > div > div').addClass('hidden');
                    var $loading = this.$dropdown.find('.direction_loading');
                    $loading.removeClass('hidden');

                    if (!this.data.isLoaded.data && this.mode !== MODE_ONLY_HOTELS) {
                        var $countriesWrapper = this.$variantsWrapper;
                        // TODO нормальный прелоадер
                        $countriesWrapper.html(this._getVariantsHint(this.messages.waitLoading));
                        return false;
                    }

                    return true;
                }

                /**
                 * @param {string} messageHtml
                 * @private
                 */

            }, {
                key: "_getVariantsHint",
                value: function _getVariantsHint(messageHtml) {
                    return '<p>' + messageHtml + '</p>';
                }
            }, {
                key: "_afterRenderDestinationDropDown",
                value: function _afterRenderDestinationDropDown() {
                    var $loading = this.$dropdown.find('.direction_loading');
                    // показываем выбор
                    this.$dropdown.find('.direction_dropdown > div > div').removeClass('hidden');
                    $loading.addClass('hidden');
                }

                /**
                 * Текущее выбранное направление
                 * @return {string}
                 */

            }, {
                key: "_getCurrentDestinationHtml",
                value: function _getCurrentDestinationHtml() {
                    var html = '';

                    var values = this._values;
                    var departCityId = values.departCityId;
                    var countryId = values.countryId;

                    var item = {
                        name: 'wsf-selected',
                        is_active: true,
                        disabled: false,
                        title: '',
                        type: '',
                        depart_city_id: departCityId,
                        country_id: countryId,
                        value: '',
                        price: 0,
                        cur: '',
                        labelUppercase: true
                    };

                    if (this.mode === MODE_ONLY_HOTELS || values.selectedHotel && this.isHotelsSearchEnabled) {
                        if (values.selectedHotel) {
                            item.type = TYPE_HOTEL;
                            item.title = values.selectedHotel.name;
                            item.value = values.selectedHotel.id;
                        }
                    } else if (values.regionIds.length) {
                        // item.type = TYPE_REGION;
                        // item.title = this.data.getRegionName(countryId, values.regionId) +
                        //     ', <span>' + this.data.getCountry(countryId).name + '</span>';
                        // item.value = values.regionId;
                    } else if (countryId) {
                        // const directionPrice = this.data.getDirectionPrice(departCityId, countryId);
                        // item.type = TYPE_COUNTRY;
                        // item.value = countryId;
                        // item.title = this.data.getCountry(countryId).name;
                        // item.price = directionPrice.value;
                        // item.cur = directionPrice.currency;
                    }
                    if (item.title !== '') {
                        html += '<div class="direction_selected">' + this._getDirectionsItemHtml(item) + '</div>';
                    }

                    return html;
                }

                /**
                 * @return {string}
                 * @private
                 */

            }, {
                key: "_getCountriesListHtml",
                value: function _getCountriesListHtml() {
                    var directions = this.data.getSortedDirections(this._values.departCityId);
                    var otherDirections = this.data.getOtherSortedDirections(this._values.departCityId);

                    var html = this._getDirectionsHtml(directions, '');
                    if (otherDirections.length) {
                        html += this._getDirectionsHtml(otherDirections, this.messages.labelOtherCitiesGroup);
                    }

                    return html;
                }

                /**
                 * @param {Array} directions
                 * @param {string} header
                 * @return {string}
                 * @private
                 */

            }, {
                key: "_getDirectionsHtml",
                value: function _getDirectionsHtml(directions, header) {
                    var html = '<div class="direction_all">';
                    if (header !== '') {
                        html += '<div class="header">' + header + '</div>';
                    }
                    html += '<ul>';

                    var i = void 0;
                    var direction = void 0;
                    var text = void 0;
                    for (i = 0; i < directions.length; i++) {
                        direction = directions[i];
                        var countryId = direction.country.id;
                        var departCityId = direction.departCity.id;
                        var code = direction.country.code;

                        html += '<li class="direction_country">';
                        text = this.data.getCountry(countryId).name;
                        if (this._values.departCityId !== departCityId) {
                            text += ' ' + this.allMessages.templateFromCity(this.data.getCity(departCityId).nameFrom);
                        }

                        var isChecked = this._values.countryId === countryId && this._values.departCityId === departCityId;

                        html += this._getDirectionsItemHtml({
                            name: 'wsf-country',
                            type: TYPE_COUNTRY,
                            is_active: isChecked,
                            title: text,
                            depart_city_id: departCityId,
                            country_id: countryId,
                            value: countryId,
                            price: direction.price,
                            cur: direction.currency,
                            disabled: false,
                            labelUppercase: true,
                            code: code
                        });
                        html += '</li>';
                    }
                    html += '</ul></div>';

                    return html;
                }

                /**
                 * @private
                 */

            }, {
                key: "_getRegionsListHtml",
                value: function _getRegionsListHtml() {
                    var html = '';

                    var values = this._values;
                    var departCityId = values.departCityId;
                    var countryId = values.countryId;

                    var regions = this.data.getSortedRegions(countryId);
                    if (regions.length === 0 && !this.data.isLoaded.nonPopularRegions) {
                        html = this.messages.waitLoading;
                        this._loadRegions();
                    } else {
                        html += '<div class="direction_popular"><ul><li class="direction_country">';
                        // Рисуем элемент "Все регионы"
                        var directionPrice = this.data.getDirectionPrice(departCityId, countryId);
                        html += this._getDirectionsItemHtml({
                            name: 'region',
                            type: TYPE_REGION,
                            value: REGION_ID_ALL,
                            is_active: this._values.isRegionSelected(REGION_ID_ALL, departCityId),
                            depart_city_id: departCityId,
                            country_id: countryId,
                            title: this.messages.allResorts + ', <span>' + this.data.getCountry(countryId).name + '</span>',
                            disabled: false,
                            price: directionPrice.value,
                            cur: directionPrice.currency,
                            inputType: INPUT_CHECKBOX,
                            labelUppercase: false
                        });

                        html += '</li></ul></div>';
                        var popularRegions = regions.slice(0, 3);
                        var otherRegions = regions.slice(3);
                        if (popularRegions.length) {
                            html += '<div class="direction_popular">';
                            html += '<div class="header">' + this.messages.labelPopularGroup + '</div><ul>';
                            html += this._getRegionItemsHtml(popularRegions);
                            html += '</ul></div>';
                        }
                        if (otherRegions.length) {
                            html += '<div class="direction_popular">';
                            html += '<div class="header">' + this.messages.labelOtherGroup + '</div><ul>';
                            html += this._getRegionItemsHtml(otherRegions);
                            html += '</ul></div>';
                        }
                    }
                    return html;
                }

                /**
                 * @param {Array} regions
                 * @return {string}
                 * @private
                 */

            }, {
                key: "_getRegionItemsHtml",
                value: function _getRegionItemsHtml(regions) {
                    var html = '';
                    var region = void 0;

                    var values = this._values;
                    var departCityId = values.departCityId;
                    var countryId = values.countryId;

                    for (var i = 0; i < regions.length; i++) {
                        region = regions[i];
                        html += '<li class="direction_country">';
                        html += this._getDirectionsItemHtml({
                            name: 'region',
                            type: TYPE_REGION,
                            value: region.id,
                            is_active: this._values.isRegionSelected(region.id, departCityId),
                            depart_city_id: departCityId,
                            country_id: countryId,
                            title: region.name + ', <span>' + this.data.getCountry(countryId).name + '</span>',
                            disabled: false,
                            price: region.price,
                            cur: region.cur,
                            inputType: INPUT_CHECKBOX,
                            labelUppercase: false
                        });
                        html += '</li>';
                    }

                    return html;
                }

                /**
                 * @param {{
                 *  name: string,
                 *  type: string,
                 *  title: string,
                 *  value: number|string,
                 *  depart_city_id: number,
                 *  country_id: number,
                 *  price: number,
                 *  cur: string,
                 *  is_active: boolean,
                 *  disabled: boolean,
                 *  inputType?: string,
                 *  labelUppercase: boolean,
                 *  country_code: number
                 * }} item
                 * @return {string}
                 * @private
                 */

            }, {
                key: "_getDirectionsItemHtml",
                value: function _getDirectionsItemHtml(item) {
                    var inputType = item.inputType || INPUT_RADIO;
                    var checked = item.is_active ? 'checked="checked"' : '';
                    var html = '';
                    var price = '';
                    var countryImage = '';

                    if (item.price !== 0) {
                        price += '<div class="price">' + this.allMessages.priceFrom + ' ' + window.utils.nfm(item.price) + ' ' + item.cur + '</div>';
                    }

                    if (item.code) {
                        countryImage = '<img src="/img/flag/round/' + item.code + '.svg" alt="">';
                    }

                    html += '<div class="checkbox full-filling_checkbox">' + '<input type="' + inputType + '" class="destination-item" ' + 'name="' + item.name + '" ' + 'value="' + item.value + '" ' + 'data-value="' + item.value + '" ' + 'data-type="' + item.type + '" ' + (item.disabled ? 'disabled ' : '') + checked + 'data-city="' + item.depart_city_id + '" ' + 'data-country="' + item.country_id + '">' + '<label' + (item.labelUppercase ? ' class="uppercase"' : '') + '>' + countryImage + item.title + price + '</label>' + '</div>';

                    return html;
                }
                // ------------------------------------------------------------------------------ RENDER DESTINATION DROPDOWN END


                // ------------------------------------------------------------------------------------------- AUTOCOMPLETE START

            }, {
                key: "_loadRegions",
                value: function _loadRegions() {
                    var _this4 = this;

                    if (this.isLoadRegionsStarted) {
                        return;
                    }
                    this.isLoadRegionsStarted = true;
                    if (this.data.isLoaded.nonPopularRegions || this.mode === MODE_ONLY_HOTELS) {
                        return;
                    }
                    this.data.loadRegions(function () {
                        if (_this4.isAutocompleteSearch) {
                            _this4._onDestinationEnter(true);
                        } else {
                            _this4.renderDestinationDropDown();
                        }
                    });
                }

                /**
                 * @param {boolean} afterLazyLoadRegions
                 * @private
                 */

            }, {
                key: "_onDestinationEnter",
                value: function _onDestinationEnter() {
                    var _this5 = this;

                    var afterLazyLoadRegions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    if (this.timers.input) {
                        clearTimeout(this.timers.input);
                        this.timers.input = null;
                    }
                    this.timers.input = setTimeout(function () {
                        _this5._searchDestination(_this5.elements.$input.val().trim(), afterLazyLoadRegions);
                    }, this.debounceInputTime);
                }

                /**
                 * @param {string} slug
                 * @param {boolean} afterLazyLoadRegions
                 * @private
                 */

            }, {
                key: "_searchDestination",
                value: function _searchDestination(slug, afterLazyLoadRegions) {
                    var _this6 = this;

                    this.autocompleteLastSlug = slug;
                    if (slug === '') {
                        this.data.abortGetDestinationsRequest();
                        // При сбросе считаем что клиент ничего не выбрал
                        this.resetSelection(false);
                        return;
                    }
                    this._beforeRenderDestinationDropDown();
                    this._showDestinationResetButton();
                    this.isAutocompleteSearch = true;

                    if (!this.data.isLoaded.nonPopularRegions) {
                        this._loadRegions();
                    }

                    if (afterLazyLoadRegions) {
                        if (this.lastResponseCache && this.lastResponseCache.query === slug) {
                            this._onDestinationsResponse(this.lastResponseCache);
                        }
                    } else {
                        this.data.getDestinations(slug, function (response) {
                            _this6._onDestinationsResponse(response);
                        }, this._values.countryId);

                        // Показывает loading
                        this.$variantsWrapper.html(this._getVariantsHint(this.messages.searchLoading));
                    }
                    this._afterRenderDestinationDropDown();
                }

                /**
                 * Разбираем ответ, отрисовываем варианты
                 * @param response
                 * @return {boolean}
                 * @private
                 */

            }, {
                key: "_onDestinationsResponse",
                value: function _onDestinationsResponse(response) {
                    if (!response.success) {
                        // При ошибке выводим обычный dropDown, вместе
                        this.renderDestinationDropDown();
                        // Можно перед выдачей вывести сообщение "не найдено" или добавить callback и показать tooltip
                        // this.$variantsWrapper.prepend(
                        //     this._getVariantsHint('По вашему запросу не найдено соответсвий =(')
                        // );
                        return false;
                    }

                    var query = response.query;
                    response = response.result;

                    var countriesCount = response.countries.length;
                    var regionsCount = response.regions.length;

                    var i = void 0;
                    var j = void 0;
                    var k = void 0;
                    var item = void 0;

                    var responseCountries = {};
                    for (i = 0; i < countriesCount; i++) {
                        item = response.countries[i];
                        if (this.data.countries.hasOwnProperty(item.id)) {
                            responseCountries[item.id] = 1;
                        }
                    }
                    var responseRegions = {};
                    for (i = 0; i < regionsCount; i++) {
                        item = response.regions[i];
                        if (this.data.isRegionExists(item.countryId, item.id)) {
                            if (!responseRegions.hasOwnProperty(item.countryId)) {
                                responseRegions[item.countryId] = [];
                                // Совпадение по региону, но в ответе нет такой страны. Добавляем в общий список
                                // Такой формат только для сохранения совместимости с предыдущим порядком вывода
                                if (!responseCountries.hasOwnProperty(item.countryId)) {
                                    responseCountries[item.countryId] = 0;
                                }
                            }

                            responseRegions[item.countryId].push(item.id);
                        }
                    }

                    var list = [];
                    var listWithDepart = [];
                    var inputName = 'wsf-destination';

                    var selectedDepartCityId = this._values.departCityId;

                    var countryId = void 0;
                    var country = void 0;
                    var countryDepartCitiesId = void 0;
                    var isSelectedDepartCityAvailable = void 0;
                    var departCityId = void 0;
                    var directionPrice = void 0;
                    var regionId = void 0;
                    var region = void 0;
                    var isCountryInResult = void 0;

                    var tmpItem = void 0;
                    for (countryId in responseCountries) {
                        countryId = Number(countryId);
                        if (!this.data.countries.hasOwnProperty(countryId)) {
                            continue;
                        }

                        isCountryInResult = responseCountries[countryId];

                        country = this.data.countries[countryId];
                        countryDepartCitiesId = this.data.getSortedCountryDepartCities(country.departs, selectedDepartCityId);
                        isSelectedDepartCityAvailable = country.departs.indexOf(selectedDepartCityId) !== -1;

                        if (isCountryInResult) {
                            // Страна есть в ответе, показываем для выбора
                            for (i = 0; i < countryDepartCitiesId.length; i++) {
                                departCityId = countryDepartCitiesId[i];
                                directionPrice = this.data.getDirectionPrice(departCityId, countryId);

                                tmpItem = {
                                    name: inputName,
                                    type: TYPE_COUNTRY,
                                    is_active: false,
                                    title: country.name + ' ' + this.allMessages.templateFromCity(this.data.cities[departCityId].nameFrom),
                                    depart_city_id: departCityId,
                                    country_id: countryId,
                                    value: countryId,
                                    price: directionPrice.value,
                                    cur: directionPrice.currency,
                                    disabled: false,
                                    sort: country.sort,
                                    labelUppercase: false
                                };
                                if (isSelectedDepartCityAvailable) {
                                    listWithDepart.push(tmpItem);
                                } else {
                                    list.push(tmpItem);
                                }
                            }
                        }

                        if (responseRegions.hasOwnProperty(countryId)) {
                            for (j = 0; j < responseRegions[countryId].length; j++) {
                                regionId = responseRegions[countryId][j];
                                region = this.data.regions[countryId][regionId];
                                for (k = 0; k < countryDepartCitiesId.length; k++) {
                                    departCityId = countryDepartCitiesId[k];
                                    tmpItem = {
                                        name: inputName,
                                        type: TYPE_REGION,
                                        value: region.id,
                                        depart_city_id: departCityId,
                                        country_id: countryId,
                                        title: region.name + ' (' + country.name + ') ' + this.allMessages.templateFromCity(this.data.cities[departCityId].nameFrom),
                                        is_active: false,
                                        disabled: false,
                                        price: region.price,
                                        cur: region.cur,
                                        sort: country.sort,
                                        labelUppercase: false
                                    };
                                    if (isSelectedDepartCityAvailable) {
                                        listWithDepart.push(tmpItem);
                                    } else {
                                        list.push(tmpItem);
                                    }
                                }
                            }
                        }
                    }

                    listWithDepart.sort(function (a, b) {
                        return a.sort - b.sort;
                    });
                    list.sort(function (a, b) {
                        return a.sort - b.sort;
                    });

                    var destinations = listWithDepart.concat(list);
                    var html = '';
                    var isDestinationFound = true;
                    if (destinations.length) {
                        html += '<div class="direction_popular"><ul>';
                        for (var _i = 0; _i < destinations.length; _i++) {
                            html += '<li class="direction_country">';
                            html += this._getDirectionsItemHtml(destinations[_i]);
                            html += '</li>';
                        }
                        html += '</ul></div>';
                    } else {
                        isDestinationFound = false;
                    }

                    var hotelItems = this._createHotelItems(response.hotels, inputName);
                    if (hotelItems.length) {
                        html += '<div class="direction_popular hotel_list">';
                        html += '<ul>';

                        for (var _i2 = 0; _i2 < hotelItems.length; _i2++) {
                            html += '<li class="direction_country">' + this._getDirectionsItemHtml(hotelItems[_i2]) + '</li>';
                        }

                        html += '</ul>';
                        html += '</div>';
                    } else if (!isDestinationFound) {
                        // html = this._getVariantsHint(
                        //     response.query.length >= this.hotelSearchMinLength
                        //         ? 'Не найдено подходящих стран, регионов и отелей'
                        //         : 'Не найдено подходящих стран и регионов'
                        // );

                        // если не найдено ни подходящей страны, ни региона, ни отеля
                        var message = i18nTemplate(this.messages.noRequestMatches, {
                            slug: this.autocompleteLastSlug
                        });
                        var _countryId = this._getHotelSearchCountryId();
                        if (_countryId) {
                            message += ' (' + i18nTemplate(this.messages.requestDetail, {
                                country: this.data.getCountry(_countryId).name
                            }) + ')';
                        }
                        html += this._getVariantsHint(message);
                    }

                    this.$variantsWrapper.html(html);
                    this._afterRenderDestinationDropDown();
                }
            }, {
                key: "_createHotelItems",
                value: function _createHotelItems(responseHotels, inputName) {
                    var items = [];

                    var i = void 0;
                    var hotel = void 0;
                    var countryId = void 0;
                    var departCityId = void 0;
                    var isSelectedDepartCityAvailable = void 0;
                    var text = void 0;
                    for (i = 0; i < responseHotels.length; i++) {
                        hotel = responseHotels[i];
                        countryId = parseInt(hotel.countryId, 10);
                        if (!this.data.isCountryExists(countryId)) {
                            // TODO сделать чтобы в ответе были только отели по направлениям,
                            //      которые доступны для поиска
                            // может прилететь отель из страны, куда сейчас нет вылетов
                            continue;
                        }
                        isSelectedDepartCityAvailable = this.data.countries[countryId].departs.indexOf(this._values.departCityId) !== -1;

                        text = hotel.name;
                        if (isSelectedDepartCityAvailable) {
                            departCityId = this._values.departCityId;
                        } else {
                            departCityId = this.data.countries[countryId].departs[0];
                            text += ' ' + this.allMessages.templateFromCity(this.data.getCity(departCityId).nameFrom);
                        }

                        items.push({
                            name: inputName,
                            type: TYPE_HOTEL,
                            value: hotel.id,
                            depart_city_id: departCityId,
                            country_id: countryId,
                            title: text,
                            is_active: false,
                            disabled: false,
                            price: 0,
                            cur: '',
                            labelUppercase: true
                        });
                    }

                    return items;
                }

                /**
                 * Отели какой страны выдавать в автокомплите
                 * Доступно только для режима "только отели".
                 * В остальных режимах поиск по всем странам
                 * @return {number}
                 * @private
                 */

            }, {
                key: "_getHotelSearchCountryId",
                value: function _getHotelSearchCountryId() {
                    var countryId = 0;
                    if (this.mode === MODE_ONLY_HOTELS && this._values.countryId) {
                        countryId = this._values.countryId;
                    }

                    return countryId;
                }

                /**
                 * @param {string} subject
                 * @param {string} value
                 * @return {boolean}
                 * @private
                 */

            }, {
                key: "_compare",
                value: function _compare(subject, value) {
                    return subject.toLowerCase().indexOf(value.toLowerCase()) !== -1;
                }
                // ------------------------------------------------------------------------------------------- AUTOCOMPLETE END

                /**
                 * @param {boolean} isHumanReset
                 */

            }, {
                key: "resetSelection",
                value: function resetSelection(isHumanReset) {
                    if (this.mode === MODE_ONLY_HOTELS) {
                        this._values.resetHotel();
                    } else {
                        this._values.reset();
                    }
                    this._hideDestinationResetButton();
                    this.isAutocompleteSearch = false;
                    this.lastResponseCache = null;
                    this.dispatchOnChange(isHumanReset);
                }
            }, {
                key: "_getHotelSearchLengthMessage",
                value: function _getHotelSearchLengthMessage() {
                    return i18nTemplate(this.messages.minLength, {
                        min: this.hotelSearchMinLength
                    });
                }

                /**
                 * @param {boolean} isHumanChange
                 * @param {boolean} allowExternalReRender
                 */

            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange(isHumanChange) {
                    var allowExternalReRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                    this.isAutocompleteSearch = false;
                    this.lastResponseCache = null;
                    this.onChange(isHumanChange, allowExternalReRender);
                }

                /**
                 * @private
                 * @param {jQuery} $checkbox
                 */

            }, {
                key: "onRegionCheckboxChange",
                value: function onRegionCheckboxChange($checkbox) {
                    var value = Number($checkbox.val());
                    // const departCityId = Number($checkbox.data('city'));
                    var checked = $checkbox.prop('checked');
                    var isSelectAll = value === REGION_ID_ALL;

                    var $checkboxes = this.$variantsWrapper.find('input.destination-item');
                    if (isSelectAll) {
                        if (checked) {
                            this.setRegionAllItemAsSelected($checkboxes, $checkbox);
                        } else {
                            // nothing. uncheck all prevented on click
                        }
                    } else {
                        var $checkboxAll = $checkboxes.filter('[value="' + REGION_ID_ALL + '"]');
                        var variantsCount = $checkboxes.length - 1;
                        if (checked) {
                            this._values.addSelectedRegionId(value, this._values.departCityId);
                            if (variantsCount > 1 && this._values.regionIds.length === variantsCount) {
                                // Выбраны все доступные значения
                                // Оставить выбранным только "Выбрать все"
                                this.setRegionAllItemAsSelected($checkboxes, $checkboxAll);
                            } else {
                                $checkboxAll.prop('checked', false);
                                this._values.removeSelectedRegionValue(REGION_ID_ALL);
                            }
                        } else {
                            this._values.removeSelectedRegionValue(value);
                            if (this._values.regionIds.length === 0) {
                                this.setRegionAllItemAsSelected($checkboxes, $checkboxAll);
                            }
                        }
                    }
                }

                /**
                 * Установить элемент "Выбрать все" как текущий
                 * @param $checkboxes - все доступные checkbox
                 * @param $checkboxAll - checkbox "Выбрать все"
                 */

            }, {
                key: "setRegionAllItemAsSelected",
                value: function setRegionAllItemAsSelected($checkboxes, $checkboxAll) {
                    // Снимаем выбор со всех, кроме "Выбрать все"
                    $checkboxes.not($checkboxAll).filter(':checked').prop('checked', false);
                    // Эмулируем выбор "Выбрать все"
                    $checkboxAll.prop('checked', true);
                    this._values.setSelectedRegionIds([]);
                }
            }, {
                key: "messages",
                get: function get() {
                    return this.allMessages.destination;
                }
            }, {
                key: "$variantsWrapper",
                get: function get() {
                    return this.$dropdown.find('.direction_dropdown div');
                }
            }]);

            return DestinationSelect;
        }();

        window.findFormComponents = window.findFormComponents || {};
        window.findFormComponents.destination = {
            Select: DestinationSelect,
            modeList: {
                ALL: MODE_ALL,
                COUNTRY_REGION: MODE_COUNTRY_REGION,
                HOTELS: MODE_ONLY_HOTELS
            }
        };

        // module.exports = {
        //   Form: DestinationForm,
        //   mode: {
        //       ALL: MODE_ALL,
        //       COUNTRY_REGION: MODE_COUNTRY_REGION,
        //       HOTELS: MODE_ONLY_HOTELS,
        //   },
        // };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * @param params
         * @constructor
         */
        function NumberRange(params) {
            this.wrapper = params.wrapper;
            this.valueFrom = params.valueFrom;
            this.valueTo = params.valueTo;
            this.allowedValues = [1, 2];
            this.onChange = params.onChange;
            this.cssClasses = {
                wrapper: 'nr-wrapper',
                item: 'nr-item',
                selectedItemBound: 'nr-item-bound',
                selectedItemFrom: 'nr-item-left',
                selectedItemTo: 'nr-item-right',
                selectedSingle: 'nr-item-selected-single',
                selected: 'nr-item-selected',
                hoveredSingle: 'nr-item-hovered-single'
            };
            this.additionalItemCssClasses = [this.cssClasses.selectedItemBound, this.cssClasses.selectedItemFrom, this.cssClasses.selectedItemTo, this.cssClasses.selectedSingle, this.cssClasses.selected, this.cssClasses.hoveredSingle];
            this.setAllowedValues(params.values);
            this.createHandlers();
        }

        NumberRange.prototype.setAllowedValues = function (values) {
            this.allowedValues = values;
            this.render();
        };

        NumberRange.prototype.getItemCssClasses = function (value, bounds) {
            var cssClasses = [];
            if (bounds.min === bounds.max && value === bounds.min) {
                cssClasses.push(this.cssClasses.selectedSingle);
            } else {
                if (value === bounds.min) {
                    cssClasses.push(this.cssClasses.selectedItemFrom);
                    cssClasses.push(this.cssClasses.selectedItemBound);
                }
                if (value === bounds.max) {
                    cssClasses.push(this.cssClasses.selectedItemTo);
                    cssClasses.push(this.cssClasses.selectedItemBound);
                }
                if (value > bounds.min && value < bounds.max) {
                    cssClasses.push(this.cssClasses.selected);
                }
            }
            return cssClasses;
        };

        NumberRange.prototype.render = function () {
            var html = '';
            var cssClasses = [];
            var value;
            for (var i = 0; i < this.allowedValues.length; i++) {
                value = this.allowedValues[i];
                cssClasses = [this.cssClasses.item].concat(this.getItemCssClasses(value, {
                    min: this.valueFrom,
                    max: this.valueTo
                }));
                html += '<div class="' + cssClasses.join(' ') + '" data-value="' + value + '"><span>' + value + '</span></div>';
            }
            this.wrapper.addClass(this.cssClasses.wrapper).html(html);
        };

        NumberRange.prototype.setValueFrom = function (value) {
            this.valueFrom = value;
        };
        NumberRange.prototype.setValueTo = function (value) {
            this.valueTo = value;
        };

        NumberRange.prototype.onItemClick = function (value) {
            var isChoiceEnd = false;
            if (this.valueTo !== null) {
                // если выбирают первое число
                this.setValueFrom(value);
                this.setValueTo(null);
                this.refreshSelected({
                    min: value,
                    max: value
                });
            } else {
                // если выбирают второе число
                if (value < this.valueFrom) {
                    // если вторым числом выбрали число меньше первого
                    this.setValueTo(this.valueFrom);
                    this.setValueFrom(value);
                } else {
                    this.setValueTo(value);
                }
                isChoiceEnd = true;
            }
            this.onChange({
                min: this.valueFrom,
                max: this.valueTo
            }, true);
            if (isChoiceEnd) {
                this.render();
            }
        };

        NumberRange.prototype.refreshSelected = function (bounds) {
            var value;
            var cssClasses;
            var self = this;
            this.wrapper.find('.' + this.cssClasses.item).each(function () {
                value = self.getValueFromElem($(this));
                cssClasses = self.getItemCssClasses(value, bounds);
                $(this).removeClass(self.additionalItemCssClasses.join(' '));
                if (cssClasses.length) {
                    $(this).addClass(cssClasses.join(' '));
                }
            });
        };

        NumberRange.prototype.getValueFromElem = function (elem) {
            return parseInt(elem.data('value'), 10);
        };

        NumberRange.prototype.onMouseEnter = function (elem) {
            var value = this.getValueFromElem(elem);
            elem.addClass(this.cssClasses.hoveredSingle);
            if (this.valueTo === null) {
                // если выбрано первое число, но еще не выбрано второе число
                var bounds = {
                    min: Math.min(this.valueFrom, value),
                    max: Math.max(this.valueFrom, value)
                };
                this.refreshSelected(bounds);
            }
        };

        NumberRange.prototype.onMouseLeave = function (elem) {
            elem.removeClass(this.cssClasses.hoveredSingle);
        };

        NumberRange.prototype.createHandlers = function () {
            var self = this;
            this.wrapper.on('click', '.' + this.cssClasses.item, function () {
                var value = self.getValueFromElem($(this));
                self.onItemClick(value);
            }).on('mouseenter', '.' + this.cssClasses.item, function (e) {
                e.preventDefault();
                self.onMouseEnter($(this));
            }).on('mouseleave', '.' + this.cssClasses.item, function (e) {
                e.preventDefault();
                self.onMouseLeave($(this));
            });
        };

        module.exports = NumberRange;
    }, {}], 2: [function (require, module, exports) {
        var NumberRange = require('../../../../include/number-range/_js/NumberRange');

        var NightsSelect = function () {
            /**
             * @param {jQuery} $dropdown
             * @param {{
             *  onChange: function,
             *  onHide: function,
             *  values: {
             *      nightsFrom: number,
             *      nightsTo: number,
             *      availableNights: number[],
             * }
             * }} params
             */
            function NightsSelect($dropdown, params) {
                var _this7 = this;

                _classCallCheck(this, NightsSelect);

                this.$dropdown = $dropdown;

                this.defaultNights = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
                this.defaultNightsValue = { from: 7, to: 9 };

                this.nightsFrom = this.defaultNightsValue.from;
                this.nightsTo = this.defaultNightsValue.to;
                this.nights = this.defaultNights;

                /**
                 * @type {boolean}
                 */
                this.allowAutoCloseOnChange = true;

                /**
                 * @type {Function}
                 */
                this.onChange = params.onChange;

                /**
                 * @type {Function}
                 */
                this.onHide = params.onHide;

                // До инициализации виджета daysChoice
                // Устанавливаем значения по умолчанию.
                // Это нужно для того, чтобы виджет сразу был отрисован с необходимыми значениями
                var defaultValues = params.values;
                this.setValues(defaultValues.nightsFrom, defaultValues.nightsTo, defaultValues.availableNights);

                /**
                 * @type {NightsRange}
                 */
                this.nightsChoice = new NumberRange({
                    wrapper: this.$dropdown.find('.nights'),
                    values: this.defaultNights,
                    valueFrom: this.nightsFrom,
                    valueTo: this.nightsTo,
                    onChange: function onChange(bounds, isHumanChange) {
                        _this7.nightsFrom = bounds.min;
                        if (bounds.max === null) {
                            // Выбрано только 1 значение. Запрещаем закрытие автоматически
                            _this7.allowAutoCloseOnChange = false;
                            _this7.nightsTo = bounds.min;
                        } else {
                            _this7.nightsTo = bounds.max;
                        }
                        _this7.dispatchOnChange(isHumanChange);
                    }
                });
            }

            _createClass(NightsSelect, [{
                key: "isOpenedNow",
                value: function isOpenedNow() {
                    return this.$dropdown.hasClass('open');
                }
            }, {
                key: "show",
                value: function show() {
                    this.$dropdown.addClass('open');
                }
            }, {
                key: "hide",
                value: function hide() {
                    this.$dropdown.removeClass('open');
                    if (this.nightsFrom === this.nightsTo) {
                        // Перерисовка виджета для сиуации:
                        // выбрали "значение 1", провели мышью (выбран диапазон), клик снаружи - виджет закрыт.
                        // В форме лейбл пишется как выбрано "значение 1".
                        // При повторном открытии: лейбл "Значение 1", а визуально выделен диапазон.
                        this.updateNightsChoiceState();
                    }
                    this.onHide();
                }

                /**
                 * @return {jQuery}
                 */

            }, {
                key: "setValues",
                value: function setValues(nightsFrom, nightsTo, availableNights) {
                    this.nightsFrom = nightsFrom;
                    this.nightsTo = nightsTo;
                    this.nights = availableNights;

                    this._updateNightsRange();
                }

                /**
                 * @param {string} text
                 */

            }, {
                key: "updateSelectionTip",
                value: function updateSelectionTip(text) {
                    this.$dropdown.find('.info').html(text);
                }
            }, {
                key: "_updateNightsRange",
                value: function _updateNightsRange() {
                    if (this.nights.length === 0) {
                        this.nights = this.defaultNights;
                    }

                    var maxAvailable = this.nights[this.nights.length - 1];
                    var boundsNights = {
                        min: this.nightsFrom,
                        max: this.nightsTo
                    };

                    var isResetNights = false;
                    if (this.nights.indexOf(boundsNights.min) === -1) {
                        isResetNights = true;
                        if (boundsNights.min > maxAvailable) {
                            boundsNights.min = maxAvailable;
                        } else {
                            boundsNights.min = this.nights[0];
                        }
                    }
                    if (this.nights.indexOf(boundsNights.max) === -1) {
                        isResetNights = true;
                        if (boundsNights.max > maxAvailable) {
                            boundsNights.max = maxAvailable;
                        } else if (this.nights.length > 1) {
                            boundsNights.max = this.nights[1];
                        } else {
                            boundsNights.max = this.nights[0];
                        }
                    }

                    if (isResetNights) {
                        // вычисление min|max нужно на случай,
                        // если
                        // значение ночей ОТ в новом списке есть, а ночей ДО нет. и выставляется от 15 до 8
                        this.nightsFrom = Math.min(boundsNights.min, boundsNights.max);
                        this.nightsTo = Math.max(boundsNights.min, boundsNights.max);
                    }

                    if (this.nightsChoice) {
                        this.updateNightsChoiceState();
                        if (isResetNights) {
                            this.dispatchOnChange(false);
                        }
                    }
                }
            }, {
                key: "updateNightsChoiceState",
                value: function updateNightsChoiceState() {
                    this.nightsChoice.setValueFrom(this.nightsFrom);
                    this.nightsChoice.setValueTo(this.nightsTo);
                    // Внутри перерисовка.
                    // Устанавливаем допустимые значения после setValueFrom/setValueTo
                    this.nightsChoice.setAllowedValues(this.nights);
                }

                /**
                 * @param {boolean} isHumanChange
                 */

            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange(isHumanChange) {
                    this.onChange(isHumanChange);
                    this.allowAutoCloseOnChange = true;
                }
            }, {
                key: "$label",
                get: function get() {
                    return this.$dropdown.find('.duration_field');
                }
            }]);

            return NightsSelect;
        }();

        window.findFormComponents = window.findFormComponents || {};
        window.findFormComponents.NightsSelect = NightsSelect;
    }, { "../../../../include/number-range/_js/NumberRange": 1 }] }, {}, [2]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var CSS_CLASS_ITEM_SELECTED = 'form-dropdown_item__selected';
        var CSS_CLASS_ITEM_SELECTED_CHECKBOX = '';

        var TYPE_RADIO = 'radio';
        var TYPE_CHECKBOX = 'checkbox';

        var CHECKBOX_SELECTOR = 'input';
        var ITEM_SELECTOR = '.form-dropdown_item';

        /**
         * Элемент списка
         */

        var SelectItem =
        /**
         * @param {{
         *     value: string|number,
         *     label: string,
         *     selectAll?: boolean,
         * }} props
         */
        function SelectItem(props) {
            _classCallCheck(this, SelectItem);

            this.value = props.value;
            this.label = props.label;
            /**
             * При клике - "выбрать все"
             * @type {boolean}
             */
            this.selectAll = props.selectAll || false;
        };

        var DropdownValues = function () {
            function DropdownValues() {
                _classCallCheck(this, DropdownValues);

                /**
                 * ID Выбранных элементов
                 * @type {string[]}
                 */
                this.selected = [];
            }

            /**
             * @param {string|number} value
             * @return {boolean}
             */


            _createClass(DropdownValues, [{
                key: "isSelected",
                value: function isSelected(value) {
                    return this.selected.indexOf(value.toString()) !== -1;
                }

                /**
                 * @param {string[]} values
                 */

            }, {
                key: "setSelectedValues",
                value: function setSelectedValues(values) {
                    this.selected = values;
                }

                /**
                 * @param {string} value
                 */

            }, {
                key: "addSelectedValue",
                value: function addSelectedValue(value) {
                    if (!this.isSelected(value)) {
                        this.selected.push(value);
                    }
                }

                /**
                 * @param {string} value
                 */

            }, {
                key: "removeSelectedValue",
                value: function removeSelectedValue(value) {
                    var index = this.selected.indexOf(value);
                    if (index !== -1) {
                        this.selected.splice(index, 1);
                    }
                }
            }, {
                key: "setSelectedOne",
                value: function setSelectedOne(value) {
                    this.setSelected([value]);
                }

                /**
                 * @return {string|null}
                 */

            }, {
                key: "getSelectedOne",
                value: function getSelectedOne() {
                    return this.selected.length ? this.selected[0] : null;
                }

                /**
                 * @param {string[]|number[]} values
                 */

            }, {
                key: "setSelected",
                value: function setSelected(values) {
                    var _this8 = this;

                    this.selected = [];
                    values.forEach(function (value) {
                        _this8.selected.push(value.toString());
                    });
                }
            }]);

            return DropdownValues;
        }();

        var BaseSearchFormDropdown = function () {
            /**
             * @param {{
             *  $dropdown: jQuery,
             *  onChange: Function,
             *  dropdownLabelSelector: string,
             *  getCustomLabel: Function,
             * }} props
             * @param {string} inputType
             */
            function BaseSearchFormDropdown(props, inputType) {
                _classCallCheck(this, BaseSearchFormDropdown);

                /** @type {string} */
                this.inputType = inputType;
                this.$dropdown = props.$dropdown;
                this.elements = {
                    $label: this.$dropdown.find(props.dropdownLabelSelector)
                };

                this.getCustomLabel = props.getCustomLabel;
                /** @type {Function} */
                this.onChange = props.onChange;
                this.values = new DropdownValues();
            }

            _createClass(BaseSearchFormDropdown, [{
                key: "isOpenedNow",
                value: function isOpenedNow() {
                    return this.$dropdown.hasClass('open');
                }
            }, {
                key: "show",
                value: function show() {
                    this.$dropdown.addClass('open');
                }
            }, {
                key: "hide",
                value: function hide() {
                    this.$dropdown.removeClass('open');
                }

                /**
                 * Render dropdown item
                 * @protected
                 * @param {SelectItem[]} items
                 */

            }, {
                key: "renderItems",
                value: function renderItems(items) {
                    var itemsHtml = '';
                    for (var i in items) {
                        itemsHtml += this.renderItem(items[i]);
                    }
                    if (itemsHtml !== '') {
                        this.$dropdown.find('.form_dropdown_menu').addClass('form_dropdown_menu--custom').html(itemsHtml);
                    }
                }

                /**
                 * @param {boolean} isHumanChange
                 */

            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange(isHumanChange) {
                    this.onChange(isHumanChange);
                }

                /**
                 * @private
                 * @param {SelectItem} item
                 */

            }, {
                key: "renderItem",
                value: function renderItem(item) {
                    var isAll = Number(item.selectAll);
                    var isSelected = void 0;
                    if (this.inputType === TYPE_CHECKBOX && isAll) {
                        isSelected = this.values.selected.length === 0;
                    } else {
                        isSelected = this.values.isSelected(item.value);
                    }

                    var selectedCssClass = this.inputType === TYPE_RADIO ? CSS_CLASS_ITEM_SELECTED : CSS_CLASS_ITEM_SELECTED_CHECKBOX;

                    var checked = isSelected ? 'checked' : '';
                    var iconCssClass = 'hidden';
                    var itemCssClass = isSelected ? selectedCssClass : '';
                    if (this.inputType === TYPE_CHECKBOX) {
                        itemCssClass += ' full-filling_checkbox full-filling_checkbox--sm';
                        iconCssClass = '';
                    }

                    return "<div class=\"form-dropdown_item " + itemCssClass + "\"" + ' data-value="' + item.value + '">' + ("<input type=\"" + this.inputType + "\"\n                    class=\"" + iconCssClass + "\"\n                    " + checked + "\n                    value=\"" + item.value + "\"\n                    data-all=\"" + isAll + "\">\n            <label>" + item.label + "</label>") + '</div>';
                }
            }]);

            return BaseSearchFormDropdown;
        }();

        var SearchFormDropdownMultiple = function (_BaseSearchFormDropdo) {
            _inherits(SearchFormDropdownMultiple, _BaseSearchFormDropdo);

            /**
             * @param {{
             *  $dropdown: jQuery,
             *  onChange: Function,
             *  dropdownLabelSelector: string,
             *  getCustomLabel: Function,
             * }} props
             */
            function SearchFormDropdownMultiple(props) {
                _classCallCheck(this, SearchFormDropdownMultiple);

                return _possibleConstructorReturn(this, (SearchFormDropdownMultiple.__proto__ || Object.getPrototypeOf(SearchFormDropdownMultiple)).call(this, props, TYPE_CHECKBOX));
            }

            /**
             * @param {string[]|number[]} values
             * @param {SelectItem[]} items
             */


            _createClass(SearchFormDropdownMultiple, [{
                key: "init",
                value: function init(values, items) {
                    this.values.setSelected(values);
                    this.renderItems(items);
                    this.renderLabel();
                    this.attachHandlersOnce();
                }

                /**
                 * @return {string[]}
                 */

            }, {
                key: "attachHandlersOnce",
                value: function attachHandlersOnce() {
                    var _this10 = this;

                    this.$dropdown.on('click', "" + ITEM_SELECTOR, function (event) {
                        var $item = $(event.currentTarget);
                        var $checkbox = $item.find(CHECKBOX_SELECTOR);

                        var isSelectAll = Number($checkbox.data('all')) === 1;
                        var isChecked = $checkbox.prop('checked');
                        if (isSelectAll && isChecked) {
                            event.preventDefault();
                            event.stopPropagation();
                            return;
                        }

                        $checkbox.prop('checked', !isChecked);
                        _this10.onItemChange($checkbox, true);
                    });
                }

                /**
                 * @private
                 * @param {jQuery} $checkbox
                 * @param {boolean} isHumanChange
                 */

            }, {
                key: "onItemChange",
                value: function onItemChange($checkbox, isHumanChange) {
                    var $item = $checkbox.closest(ITEM_SELECTOR);
                    var value = $checkbox.val();
                    var checked = $checkbox.prop('checked');
                    var isSelectAll = Number($checkbox.data('all')) === 1;

                    var allowDispatchOnChange = true;
                    var $checkboxes = this.$dropdown.find(ITEM_SELECTOR + " " + CHECKBOX_SELECTOR);
                    if (isSelectAll) {
                        if (checked) {
                            this.setAllItemAsSelected($checkboxes, $checkbox);
                        } else {
                            // nothing. uncheck all prevented on click
                            allowDispatchOnChange = false;
                        }
                    } else {
                        var $checkboxAll = $checkboxes.filter('[data-all="1"]');
                        if (checked) {
                            this.values.addSelectedValue(value);
                            if (this.values.selected.length === $checkboxes.length - 1) {
                                // Выбраны все доступные значения
                                // Оставить выбранным только "Выбрать все"
                                this.setAllItemAsSelected($checkboxes, $checkboxAll);
                            } else {
                                $item.addClass(CSS_CLASS_ITEM_SELECTED_CHECKBOX);
                                $checkboxAll.closest(ITEM_SELECTOR).removeClass(CSS_CLASS_ITEM_SELECTED_CHECKBOX);
                                $checkboxAll.prop('checked', false);
                                this.values.removeSelectedValue($checkboxAll.val());
                            }
                        } else {
                            this.values.removeSelectedValue(value);
                            $item.removeClass(CSS_CLASS_ITEM_SELECTED_CHECKBOX);
                            if (this.values.selected.length === 0) {
                                this.setAllItemAsSelected($checkboxes, $checkboxAll);
                            } else {
                                $checkboxAll.prop('checked', false);
                                $checkboxAll.closest(ITEM_SELECTOR).removeClass(CSS_CLASS_ITEM_SELECTED_CHECKBOX);
                            }
                        }
                    }

                    if (allowDispatchOnChange) {
                        this.dispatchOnChange(isHumanChange);
                        this.renderLabel();
                    }
                }

                /**
                 * Установить элемент "Выбрать все" как текущий
                 * @param $checkboxes - все доступные checkbox
                 * @param $checkboxAll - checkbox "Выбрать все"
                 */

            }, {
                key: "setAllItemAsSelected",
                value: function setAllItemAsSelected($checkboxes, $checkboxAll) {
                    // Снимаем выбор со всех, кроме "Выбрать все"
                    var $checkedCheckboxes = $checkboxes.not($checkboxAll).filter(':checked');
                    $checkedCheckboxes.prop('checked', false);
                    $checkedCheckboxes.closest(ITEM_SELECTOR).removeClass(CSS_CLASS_ITEM_SELECTED_CHECKBOX);

                    // Эмулируем выбор "Выбрать все"
                    $checkboxAll.prop('checked', true);
                    $checkboxAll.closest(ITEM_SELECTOR).addClass(CSS_CLASS_ITEM_SELECTED_CHECKBOX);
                    this.values.setSelected([]);
                }

                /** @private */

            }, {
                key: "renderLabel",
                value: function renderLabel() {
                    this.elements.$label.html(this.getCustomLabel());
                }
            }, {
                key: "selectedValues",
                get: function get() {
                    return this.values.selected;
                }
            }]);

            return SearchFormDropdownMultiple;
        }(BaseSearchFormDropdown);

        /**
         * Выбор одного единственного элемента
         */


        var SearchFormDropdown = function (_BaseSearchFormDropdo2) {
            _inherits(SearchFormDropdown, _BaseSearchFormDropdo2);

            /**
             * @param {{
             *  $dropdown: jQuery,
             *  onChange: Function,
             *  dropdownLabelSelector: string,
             *  getCustomLabel: Function|null,
             * }} props
             */
            function SearchFormDropdown(props) {
                _classCallCheck(this, SearchFormDropdown);

                /** @type {Function|null} */
                var _this11 = _possibleConstructorReturn(this, (SearchFormDropdown.__proto__ || Object.getPrototypeOf(SearchFormDropdown)).call(this, props, TYPE_RADIO));

                _this11.getCustomLabel = props.getCustomLabel || null;
                return _this11;
            }

            /**
             * @return {string|null}
             */


            _createClass(SearchFormDropdown, [{
                key: "init",


                /**
                 * @param {string|number} value
                 * @param {SelectItem[]} items
                 */
                value: function init(value, items) {
                    this.values.setSelectedOne(value);
                    this.renderItems(items);
                    this.attachHandlersOnce();
                }

                /**
                 * @protected
                 * @param items
                 */

            }, {
                key: "renderItems",
                value: function renderItems(items) {
                    _get(SearchFormDropdown.prototype.__proto__ || Object.getPrototypeOf(SearchFormDropdown.prototype), "renderItems", this).call(this, items);
                    this.renderLabel();
                }

                /**
                 * @private
                 */

            }, {
                key: "attachHandlersOnce",
                value: function attachHandlersOnce() {
                    var _this12 = this;

                    this.$dropdown.on('click', '.form-dropdown_item', function (event) {
                        var $item = $(event.currentTarget);
                        var value = $item.data('value');
                        _this12.setValue(value, true, true);
                        _this12.hide();
                    });
                }

                /**
                 * @param {*} value
                 * @param {boolean} isHumanChange
                 * @param {boolean} forceRunOnChange - вызвать onChange,
                 *      даже если элемент активный.
                 *      Понадобилось для ситуации, когда открыли dropdown автоматически
                 *      и клиент кликнул по уже активному элементу.
                 *      При этом нужно открыть следующий селект (происходит только после выбора)
                 */

            }, {
                key: "setValue",
                value: function setValue(value) {
                    var isHumanChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var forceRunOnChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                    var $newItem = this.$dropdown.find('.form-dropdown_item[data-value="' + value + '"]');
                    if ($newItem.length) {
                        var isValueChanged = !this.values.isSelected(value);
                        this.values.setSelectedOne(value);

                        var $selectedItem = this.$dropdown.find('.' + CSS_CLASS_ITEM_SELECTED);
                        $selectedItem.removeClass(CSS_CLASS_ITEM_SELECTED);
                        $selectedItem.find(CHECKBOX_SELECTOR).prop('checked', false);
                        $newItem.addClass(CSS_CLASS_ITEM_SELECTED);
                        $newItem.find(CHECKBOX_SELECTOR).prop('checked', true);

                        this.renderLabel();

                        if (isValueChanged || forceRunOnChange) {
                            this.dispatchOnChange(isHumanChange);
                        }
                    } else {
                        console.warn('value %s not found', value);
                    }
                }

                /** @private */

            }, {
                key: "renderLabel",
                value: function renderLabel() {
                    this.elements.$label.html(this.getLabel());
                }

                /** @private */

            }, {
                key: "getLabel",
                value: function getLabel() {
                    return this.getCustomLabel(this.selectedValue);
                }
            }, {
                key: "selectedValue",
                get: function get() {
                    return this.values.getSelectedOne();
                }
            }]);

            return SearchFormDropdown;
        }(BaseSearchFormDropdown);

        window.findFormComponents = window.findFormComponents || {};
        window.findFormComponents.SearchFormDropdownItem = SelectItem;
        window.findFormComponents.SearchFormDropdownMultiple = SearchFormDropdownMultiple;
        window.findFormComponents.SearchFormDropdown = SearchFormDropdown;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * value не храним в свойствах, так как есть кейсы когда это значение будет меняться снаружи
         * @param wrapper
         * @param bounds
         * @param value
         * @param onChange
         * @constructor
         */
        function Counter(wrapper, bounds, value, onChange) {
            this.wrapper = wrapper;
            this.bounds = bounds;
            this.onChange = onChange;

            this.setValue(value, false);
            this.createHandlers();
        }

        Counter.prototype.createHandlers = function () {
            var self = this;
            $('button', this.wrapper).on('click', function () {
                var diff = $(this).hasClass('next') ? 1 : -1;
                self.changeValue(diff);
            });
        };

        Counter.prototype.changeValue = function (diff) {
            var newValue = this.getValue() + diff;
            if (newValue < this.bounds.min || newValue > this.bounds.max) {
                return;
            }
            this.setValue(newValue, true);
        };

        Counter.prototype.setValue = function (newValue, isHumanChange) {
            this.wrapper.find('span').text(newValue);
            this.wrapper.find('.next, .prev').removeClass('disable');
            if (newValue + 1 > this.bounds.max) {
                this.wrapper.find('.next').addClass('disable');
            }
            if (newValue - 1 < this.bounds.min) {
                this.wrapper.find('.prev').addClass('disable');
            }
            this.onChange(newValue, isHumanChange);
        };

        Counter.prototype.getValue = function () {
            return parseInt(this.wrapper.find('span').text(), 10);
        };

        module.exports = Counter;
    }, {}], 2: [function (require, module, exports) {
        var Counter = require('../../../../include/counter/_js/Counter');

        var TouristsSelect = function () {
            /**
             * @param {jQuery} $dropdown
             * @param {{
             *  onChange: function,
             *  values: SearchFormValues
             * }} params
             */
            function TouristsSelect($dropdown, params) {
                var _this13 = this;

                _classCallCheck(this, TouristsSelect);

                this.$dropdown = $dropdown;

                this.onChange = params.onChange;

                this.bounds = {
                    adults: {
                        min: 1,
                        max: 10
                    },
                    children: {
                        min: 0,
                        max: 4
                    },
                    childrenAges: {
                        min: 0,
                        max: 15
                    }
                };

                /**
                 * @type {{adult: number, child: number, childAges: Array}}
                 */
                this.values = {
                    adult: params.values.adult,
                    child: params.values.child,
                    childAges: params.values.childAges
                };

                // кол-во взрослых
                this.adults = new Counter($('.adults-count', this.$dropdown), this.bounds.adults, this.values.adult, function (newValue, isHumanChange) {
                    _this13.onChangeAdultCount(newValue, isHumanChange);
                });

                this.renderSelectedChildren();
                this.toggleAddChildDropdown();

                this.attachHandlersOnce();
            }

            _createClass(TouristsSelect, [{
                key: "isOpenedNow",
                value: function isOpenedNow() {
                    return this.$dropdown.hasClass('open');
                }
            }, {
                key: "show",
                value: function show() {
                    this.$dropdown.addClass('open');
                }
            }, {
                key: "hide",
                value: function hide() {
                    this.$dropdown.removeClass('open');
                }
            }, {
                key: "updateLabel",
                value: function updateLabel(text) {
                    this.$dropdown.find('.tourists_field').text(text);
                }
            }, {
                key: "onChangeAdultCount",
                value: function onChangeAdultCount(newValue, isHumanChange) {
                    this.values.adult = newValue;
                    this.dispatchOnChange(isHumanChange);
                }

                /**
                 * @param {Array<number>} childAges
                 * @param {boolean} isHumanChange
                 */

            }, {
                key: "onChangeChildrenCount",
                value: function onChangeChildrenCount(childAges, isHumanChange) {
                    this.values.child = childAges.length;
                    this.values.childAges = childAges;
                    this.dispatchOnChange(isHumanChange);
                }

                /**
                 * @param {boolean} isHumanChange
                 */

            }, {
                key: "onSelectedChildAgesChange",
                value: function onSelectedChildAgesChange(isHumanChange) {
                    var ages = [];
                    var $selectedList = this.$dropdown.find('.children-list');
                    $selectedList.find('.children-select__dropdown-list-item.active').each(function (index, item) {
                        ages.push(Number(item.dataset.value));
                    });

                    this.onChangeChildrenCount(ages, isHumanChange);
                }
            }, {
                key: "toggleAddChildDropdown",
                value: function toggleAddChildDropdown() {
                    var isNeedHidden = this.values.child === this.bounds.children.max;
                    $('#children-select .children-select__dropdown').toggleClass('hidden', isNeedHidden);
                }
            }, {
                key: "attachHandlersOnce",
                value: function attachHandlersOnce() {
                    var _this14 = this;

                    this.$dropdown.on('click', '.children-select__dropdown-toggle', function (e) {
                        var $dropdown = $(e.currentTarget).parent();
                        _this14.toggleSelectDropdownList($dropdown);
                    }).on('click', '.children-select__dropdown-list-item', function (e) {
                        var $option = $(e.currentTarget);
                        var $dropdown = $option.closest('.children-select__dropdown');
                        var isSelectedAgeItem = $dropdown.data('add') === 0;
                        if (isSelectedAgeItem) {
                            // изменить выбранное значение
                            $option.siblings('.children-select__dropdown-list-item.active').removeClass('active');
                            $option.addClass('active');
                            $dropdown.find('.children-select__dropdown-toggle .value').text($option.text());
                        } else {
                            // добавить новое
                            _this14.renderChild($option.data('value'));
                        }

                        _this14.onSelectedChildAgesChange(true);
                        _this14.toggleAddChildDropdown();
                        _this14.toggleSelectDropdownList($dropdown);
                    }).on('click', '.children-list .children-select__remove-btn', function (e) {
                        // disable outside click and dropdown close
                        e.stopPropagation();
                        var $dropdown = $(e.currentTarget).closest('.children-select__dropdown');
                        $dropdown.remove();
                        _this14.onSelectedChildAgesChange(true);
                        _this14.toggleAddChildDropdown();
                    });

                    $(document).mouseup(function (e) {
                        var $dropdown = $('.children-select__dropdown.open');
                        if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
                            $dropdown.removeClass('open');
                        }
                    });
                }
            }, {
                key: "renderSelectedChildren",
                value: function renderSelectedChildren() {
                    if (this.values.child > 0) {
                        for (var i = 0; i < this.values.child; i++) {
                            var age = this.values.childAges[i] || null;
                            if (age !== null) {
                                this.renderChild(age);
                            }
                        }
                    }
                }
            }, {
                key: "renderChild",
                value: function renderChild(age) {
                    var $dropdown = $('#children-select .children-select__dropdown').clone();
                    this.toggleSelectDropdownList($dropdown, false);
                    $dropdown.data('add', 0);

                    var $selectedItem = $dropdown.find('.children-select__dropdown-list-item[data-value="' + age + '"]');
                    $selectedItem.addClass('active');

                    $dropdown.find('.children-select__dropdown-toggle .value').text($selectedItem.text());

                    $('.children-list').append($dropdown);
                }

                /**
                 * @param $dropdown
                 * @param {boolean} forceShow
                 */

            }, {
                key: "toggleSelectDropdownList",
                value: function toggleSelectDropdownList($dropdown) {
                    var forceShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    if (forceShow === null) {
                        $dropdown.toggleClass('open');
                    } else {
                        $dropdown.removeClass('open');
                    }
                }

                /**
                 * @param {boolean} isHumanChange
                 */

            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange(isHumanChange) {
                    this.onChange(isHumanChange);
                }
            }]);

            return TouristsSelect;
        }();

        window.findFormComponents = window.findFormComponents || {};
        window.findFormComponents.TouristsSelect = TouristsSelect;
    }, { "../../../../include/counter/_js/Counter": 1 }] }, {}, [2]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // Данные формы поиска
        var SearchFormData = require('../../include/SearchFormData');
        var ONLY_CURRENT_HOTEL_SEARCH = 'hotel';

        // Значения формы поиска

        var _require = require('../../include/SearchFormValues'),
            SearchFormValues = _require.SearchFormValues,
            STARS_ANY = _require.STARS_ANY,
            MOMENT_DATE_FORMAT = _require.MOMENT_DATE_FORMAT;

        var I18nJsMessages = require('../../../../../include/_js/I18nJsMessages');
        var i18nPlural = window.utils.i18n.plural;
        var i18nTemplate = window.utils.i18n.template;

        /**
         * Сообщения для десктоп виджета.
         * Назначение: подсветка (По сути аналог интерфейса).
         *
         * @property {string} priceFrom
         * @property {string} fromCity
         * @property {string} btnSearchLoading
         * @property {string} labelDateDiff
         * @property {string} labelNights
         * @property {string} labelNightsRange
         * @property {string} datesSelected
         * @property {string} noDirectionNights
         * @property {string} noDateFlights
         * @property {string} noCountry
         * @property {string} invalidAge
         * @property {string} starsAny
         * @property {string[]} pluralStars
         * @property {string[]} pluralNights
         * @property {string[]} pluralResorts
         * @property {string[]} pluralAdults
         * @property {string[]} pluralChild
         * @property {{
         *  allResorts: string,
         *  labelPopularGroup: string,
         *  labelOtherGroup: string,
         *  labelOtherCitiesGroup: string,
         *  waitLoading: string,
         *  searchLoading: string,
         *  requestDetail: string,
         *  noRequestMatches: string,
         *  minLength: string,
         * }} destination
         * @property {{
         *     months: Array<string>,
         *     dayNames: Array<string>,
         * }} calendar
         */

        var FindFormJsMessages = function (_I18nJsMessages) {
            _inherits(FindFormJsMessages, _I18nJsMessages);

            function FindFormJsMessages() {
                _classCallCheck(this, FindFormJsMessages);

                return _possibleConstructorReturn(this, (FindFormJsMessages.__proto__ || Object.getPrototypeOf(FindFormJsMessages)).apply(this, arguments));
            }

            _createClass(FindFormJsMessages, [{
                key: "pluralizeNights",
                value: function pluralizeNights(nights) {
                    return i18nPlural(nights, this.pluralNights);
                }
            }, {
                key: "pluralizeStars",
                value: function pluralizeStars(stars) {
                    return i18nPlural(stars, this.pluralStars);
                }
            }, {
                key: "templateFromCity",
                value: function templateFromCity(cityName) {
                    return i18nTemplate(this.fromCity, {
                        city: cityName
                    });
                }
            }]);

            return FindFormJsMessages;
        }(I18nJsMessages);

        /**
         * @param {{
         *  values: {},
         *  data: {},
         *  mode: string,
         *  messages: {},
         * }} params
         * @constructor
         */


        var WideSearchForm = function () {
            function WideSearchForm(params) {
                var _this16 = this;

                _classCallCheck(this, WideSearchForm);

                /**
                 * @protected
                 * @type {FindFormJsMessages}
                 */
                this.messages = new FindFormJsMessages(params.i18nMessages);
                /**
                 * @protected
                 * @type {SearchFormValues}
                 */
                this.values = new SearchFormValues(params.values);

                /**
                 * @protected
                 * @type {SearchFormData}
                 */
                this.data = new SearchFormData(params.data);

                this.mode = 'mode' in params ? params.mode : '';

                this.isChanged = {
                    /**
                     * Был ли вручную изменен город вылета
                     * @type {boolean}
                     */
                    departCity: false,
                    /**
                     * были ли изменены вручную ночи
                     * @type {boolean}
                     */
                    nightsRange: false,
                    /**
                     * была ли выбрана вручную дата
                     * @type {boolean}
                     */
                    date: false,
                    /**
                     * было ли выбрано вручную направление
                     * @type {boolean}
                     */
                    destination: false,
                    /**
                     * были ли уже выбраны вручную кол-во человек
                     * @type {boolean}
                     */
                    tourists: false,
                    /**
                     * были ли уже выбраны вручную кол-во звезд
                     * @type {boolean}
                     */
                    stars: false
                };

                /**
                 * Разрешено автоматически открывать следующий dropdown после выбора какого либо значения
                 * @type {boolean}
                 */
                this.allowAutoOpenNext = true;

                this.hiddenElemNames = {
                    city: 'wsf-city',
                    country: 'wsf-country',
                    regions: 'wsf-regions',
                    hotel: 'wsf-hotel',
                    dateFrom: 'wsf-date-from',
                    dateTo: 'wsf-date-to',
                    nightsFrom: 'wsf-nights-from',
                    nightsTo: 'wsf-nights-to',
                    adults: 'wsf-adults',
                    children: 'wsf-children',
                    ages: 'wsf-ages',
                    stars: 'wsf-stars',
                    search: 'wsf-search'
                };

                this.elements = {
                    // Да! Прогресс бар у нас в форме поиска
                    $progressbar: null
                };

                /**
                 * Задержка для автоматического открытия следующего шага,
                 * так как иначе dropdown тут же закроется по событию клика на область за пределами dropdown
                 * @type number
                 */
                this.debounceTime = 12;

                var countryId = null;
                if (this.mode === ONLY_CURRENT_HOTEL_SEARCH && this.values.countryId) {
                    countryId = this.values.countryId;
                }
                this.data.load(function () {
                    if (!_this16.processValues()) {
                        // Переданы несовместимые значения,
                        // по какой-либо причине сбросить к дефолтному состоянию нельзя
                        _this16.destroy();
                        return;
                    }
                    _this16.init();
                }, countryId);
            }

            _createClass(WideSearchForm, [{
                key: "processValues",


                /**
                 * Обработать значения для установки на основе загруженных данных.
                 * Если выбранного направления нет в ответе - сбросить
                 */
                value: function processValues() {
                    // Если в шапке выбрали город,
                    // по которому у нас нет вылетов, то ставим город вылета по умолчанию
                    if (!this.data.isCityExists(this.values.departCityId)) {
                        var defaultCityId = this.values.getDefaultDepartCityId();
                        if (!this.data.isCityExists(defaultCityId)) {
                            // первый из доступных
                            defaultCityId = this.data.getFirstCityId();
                        }
                        this.values.departCityId = defaultCityId;
                    }

                    if (this.values.countryId && !this.data.isDirectionAvailable(this.values.departCityId, this.values.countryId)) {
                        // Направление недоступно
                        this.values.resetDestination();
                    }

                    if (this.mode === ONLY_CURRENT_HOTEL_SEARCH && !this.values.countryId) {
                        // Выбор направления скрыт. Т.к. изменить направление нет возможности - удаляем форму
                        this.destroy();
                        return false;
                    }

                    // Т.к. выше направление могло быть изменено, обновляем значения в форме
                    this.setHiddenValue(this.hiddenElemNames.city, this.values.departCityId);
                    this._setDestinationInputValues();

                    return true;
                }

                /**
                 *
                 */

            }, {
                key: "destroy",
                value: function destroy() {
                    $('.short-search').remove();
                    $('.remove-on-search-form-destroy').remove();
                    $('.hide-on-search-form-destroy').addClass('hidden');
                    // уведомить об этом hot-table,
                    // TODO: скрыть loader и т.п. вещи по необходимости
                    window.dispatchEvent(new CustomEvent('searchForm.destroyed'));
                }
                /**
                 * Выполнить действия после загрузки данных формы
                 * e.g. Отрисовать списки, выбранную страну, направление, доступные ночи и т.п.
                 */

            }, {
                key: "init",
                value: function init() {
                    // create controls
                    this.initControls();
                    // Обработчики формы
                    this.bindFormHandlersOnce();
                    // Обработчики формы поиска
                    this.bindSearchEventsSubscribes();

                    if (this.values.countryId) {
                        this.destinationSelect.renderFace();
                    }
                    if (this.destinationSelect.isOpenedNow()) {
                        this.destinationSelect.setValues(this.values);
                        this.destinationSelect.renderDestinationDropDown();
                    }

                    // диапазон, длительности отдыха (варианты ночей)
                    this.updateNightsRange();

                    this.$main.find('.short-search_body').removeClass('loading');

                    this.setHiddenValue(this.hiddenElemNames.search, 1);
                    if (this.values.isStartOnCurrentPage()) {
                        this.triggerFormSubmit();
                    }
                    // Данные загружены. С формой можно полноценно работать
                    // $(window).trigger('searchForm.dataLoaded', {widget: this});
                }
            }, {
                key: "initControls",
                value: function initControls() {
                    this.$main = $('.short-search');
                    this.elements.$header = $('header');
                    this.elements.$searchLoader = $('.search-loader');
                    this.elements.$progressLine = $('.search-loader > .bar');
                    this.elements.$progressbar = $('.search-progressbar', this.$main);

                    /**
                     * @type {SearchFormDropdown}
                     */
                    this.citySelect = null;
                    /**
                     * @type {DestinationSelect}
                     */
                    this.destinationSelect = null;
                    /**
                     * @type {DateSelect}
                     */
                    this.dateSelect = null;
                    /**
                     * @type {NightsSelect}
                     */
                    this.nightsSelect = null;
                    /**
                     * @type {SearchFormDropdownMultiple}
                     */
                    this.starsSelect = null;
                    /**
                     * @type {TouristsSelect}
                     */
                    this.touristsSelect = null;

                    // Выбор города
                    this.initCitiesSelect();
                    // Выбор направления (страны/регионы/отели)
                    this.initDestinationSelect();
                    // выбор кол-ва ночей. ВАЖНО! до initDateSelect
                    this.initNightsSelect();
                    // Выбор даты вылета
                    this.initDateSelect();
                    // Выбор класса отеля
                    this.initStarsSelect();
                    // Выбор туристов
                    this.initTouristsSelect();
                }
            }, {
                key: "bindFormHandlersOnce",
                value: function bindFormHandlersOnce() {
                    var _this17 = this;

                    $('.body_form', this.$main).on('click', '.form-title', function (event) {
                        var $parent = $(event.currentTarget).closest('.form_dropdown');
                        switch ($parent.data('type')) {
                            case 'destination':
                                if (!_this17.destinationSelect.isOpenedNow()) {
                                    _this17.destinationSelect.show(_this17.values);
                                }
                                break;
                            case 'date':
                                if (_this17.dateSelect.isOpenedNow()) {
                                    _this17.dateSelect.hide();
                                } else {
                                    _this17.dateSelect.show();
                                }
                                break;
                            case 'duration':
                                if (_this17.nightsSelect.isOpenedNow()) {
                                    _this17.nightsSelect.hide();
                                } else {
                                    _this17.nightsSelect.show();
                                }
                                break;
                            case 'depart-city':
                            case 'stars':
                            case 'tourists':
                                $parent.toggleClass('open');
                                break;
                        }
                    });

                    $('body').on('click', function (e) {
                        var $openedDropDowns = _this17.$main.find('.form_dropdown.open');
                        if ($openedDropDowns.length) {
                            var $elem = $(e.target);
                            var $parent = $elem.closest('.form_dropdown');
                            var parentDropDownType = $parent.length === 0 ? $elem.hasClass('destination-item') ? 'destination' : '' : $parent.data('type');

                            if (parentDropDownType !== '') {
                                // Исключаем родительский Dropdown.
                                // Закрытие при клике в пределах Dropdown опционально:
                                // - выбор какого-то элемента
                                // - выбор клик по .form-title
                                $openedDropDowns = $openedDropDowns.not('[data-type="' + parentDropDownType + '"]');
                            }
                            $openedDropDowns.each(function (index, element) {
                                switch (element.getAttribute('data-type')) {
                                    case 'destination':
                                        if (_this17.destinationSelect.isOpenedNow()) {
                                            _this17.destinationSelect.hide(_this17.values);
                                        }
                                        break;
                                    case 'duration':
                                        _this17.nightsSelect.hide();
                                        break;
                                    case 'date':
                                    case 'depart-city':
                                    case 'stars':
                                    case 'tourists':
                                        $(element).removeClass('open');
                                        break;
                                }
                            });
                        }
                    })
                    // ng component
                    .on('click', '.change-search-params', function (event) {
                        event.preventDefault();
                        var target = $(event.currentTarget).data('target') || 'destination';
                        switch (target) {
                            case 'date':
                                _this17.dateSelect.show();
                                break;
                            case 'destination':
                                _this17.destinationSelect.show(_this17.values);
                                break;
                            case 'nights':
                                _this17.nightsSelect.show();
                                break;
                            case 'tourists':
                                _this17.touristsSelect.show();
                                break;
                            default:
                                console.warn('Unknown target for change search params', target);
                                break;
                        }
                    });

                    // при определении города меняем город в форме поиска
                    $(window).on('onLocation', function (event, city) {
                        // если город уже успели поменять вручную, то ничего не делаем
                        if (_this17.isChanged.departCity) {
                            return;
                        }
                        if (_this17.data.isCityExists(city.depart_id)) {
                            _this17.citySelect.setValue(city.depart_id, false);
                        }
                    });

                    $('.form_search', this.$main).on('submit', function (event) {
                        if (!_this17.onSubmit()) {
                            return false;
                        }

                        var paramsValues = Object.assign({}, _this17.values);
                        paramsValues.selectedDate = _this17.values.getDateAsValue(paramsValues.selectedDate, 'YYYY-MM-DD');

                        var searchFormValuesEvent = new CustomEvent('search-form:values', {
                            detail: paramsValues
                        });

                        window.dispatchEvent(searchFormValuesEvent);

                        if (_this17.values.emitSearchParams) {
                            return false;
                        }

                        if (!_this17.values.isStartOnCurrentPage()) {
                            $('#w-st-findtours').html(_this17.messages.btnSearchLoading + ' ' + window.img_load);
                            return true;
                        }

                        event.preventDefault();

                        _this17.dispatchStartNewSearchEvent();

                        return true;
                    });

                    $('#repeatCurrentSearch').on('click', function () {
                        _this17.triggerFormSubmit();
                    });
                }
            }, {
                key: "initCitiesSelect",
                value: function initCitiesSelect() {
                    var _this18 = this;

                    this.citySelect = new this.components.SearchFormDropdown({
                        $dropdown: this.$main.find('.form_from'),
                        dropdownLabelSelector: '.form-title .from_field',
                        value: this.values.departCityId,
                        getCustomLabel: function getCustomLabel(cityId) {
                            return _this18.messages.templateFromCity(_this18.data.getCity(cityId).nameFrom);
                        },
                        onChange: function onChange(isHumanChange) {
                            _this18.values.departCityId = parseInt(_this18.citySelect.selectedValue, 10);
                            _this18.setHiddenValue(_this18.hiddenElemNames.city, _this18.values.departCityId);

                            // Обновляем город вылета в селектах. Важно: до resetSelection
                            _this18.destinationSelect.setDepartCityId(_this18.values.departCityId);

                            if (_this18.values.countryId) {
                                if (_this18.data.isDirectionAvailable(_this18.values.departCityId, _this18.values.countryId)) {
                                    // Обновляем календарь
                                    _this18._onAfterDirectionChange();
                                } else {
                                    // Направление недоступно. Сбрасываем
                                    // Обновит календарь и дни в onChange
                                    _this18.destinationSelect.resetSelection(false);
                                }
                            }

                            if (isHumanChange) {
                                _this18.isChanged.departCity = true;
                                if (_this18.allowAutoOpenNext && (!_this18.values.countryId || !_this18.isChanged.destination)) {
                                    // открываем выбор страны
                                    // открываем с задержкой, что автоматически dropdown не закрылся сразу
                                    // после открытия из за клик по body за пределами самого dropdown
                                    setTimeout(function () {
                                        // openNext
                                        _this18.destinationSelect.show(_this18.values);
                                    }, _this18.debounceTime);
                                }
                            }
                        }
                    });

                    var DropdownItem = this.components.SearchFormDropdownItem;

                    var city = void 0;
                    var cities = [];
                    for (var cityId in this.data.cities) {
                        if (!this.data.cities.hasOwnProperty(cityId)) {
                            continue;
                        }
                        city = this.data.cities[cityId];
                        cities.push(new DropdownItem({
                            value: cityId,
                            label: city.nameFrom
                        }));
                    }

                    this.citySelect.init(this.values.departCityId, cities);
                }
            }, {
                key: "initDestinationSelect",
                value: function initDestinationSelect() {
                    var _this19 = this;

                    var modeList = this.components.destination.modeList;

                    var $hotelForm = this.$main.find('.form_hotel');
                    this.destinationSelect = new this.components.destination.Select(this.$main.find('.form_direction'), this.data, {
                        values: this.values,
                        messages: this.messages,
                        mode: $hotelForm.length ? modeList.COUNTRY_REGION : modeList.ALL,
                        onChange: function onChange(isHumanChange, allowExternalReRender) {
                            if (isHumanChange) {
                                _this19.isChanged.destination = true;
                            }
                            _this19._onDestinationChange(allowExternalReRender);
                        },
                        onOpenNext: function onOpenNext() {
                            if (_this19.allowAutoOpenNext && !_this19.isChanged.date) {
                                setTimeout(function () {
                                    // openNext
                                    _this19.dateSelect.show();
                                }, _this19.debounceTime);
                            }
                        }
                    });
                }

                /**
                 * Обработка выбора направления и отдельно отеля.
                 * @note Задумка onChange в DestinationSelect в том, чтобы все изменения проходили через него.
                 *    т.к. у 2 селектов есть зависимость от значений выбранных в 1 из них - объедено в 1 метод
                 *    и обрабатывается отлично от onChange в
                 * @private
                 * @param {boolean} allowExternalReRender
                 */

            }, {
                key: "_onDestinationChange",
                value: function _onDestinationChange() {
                    var allowExternalReRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    var values = this.destinationSelect.getValues();

                    var isCountryChanged = this.values.countryId !== values.countryId;

                    // Устанавливаем новые значения
                    this.values.countryId = values.countryId;
                    this.values.setRegionIds(values.regionIds);

                    // При сбросе departCityId будет 0. В таком случае не меняем
                    if (values.departCityId && this.values.departCityId !== values.departCityId) {
                        // Страна изменена заранее, чтобы при citySelect.onChange
                        this.citySelect.setValue(values.departCityId, false);
                    }

                    this.values.resetHotel(); // Пока только 1 отель
                    if (values.selectedHotel) {
                        this.values.setSelectedHotel(values.selectedHotel.id, values.selectedHotel.name, values.selectedHotel.countryId);
                    }

                    this.destinationSelect.renderFace();
                    if (this.destinationSelect.isOpenedNow() && allowExternalReRender) {
                        this.destinationSelect.renderDestinationDropDown();
                    }

                    this._setDestinationInputValues();

                    if (isCountryChanged) {
                        this._onAfterDirectionChange();
                    }
                }
            }, {
                key: "_setDestinationInputValues",
                value: function _setDestinationInputValues() {
                    this.setHiddenValue(this.hiddenElemNames.country, this.values.countryId);
                    this.setHiddenValue(this.hiddenElemNames.regions, this.values.regionIds.join(','));
                    this.setHiddenValue(this.hiddenElemNames.hotel, this.values.getSelectedHotelsId().join(','));
                }
            }, {
                key: "initDateSelect",
                value: function initDateSelect() {
                    var _this20 = this;

                    this.dateSelect = new this.components.DateSelect(this.$main.find('.form_date'), {
                        values: this.values,
                        rangeDays: this.values.rangeDays,
                        MOMENT_DATE_FORMAT: MOMENT_DATE_FORMAT,
                        allMessages: this.messages,
                        onChange: function onChange(isHumanChange) {
                            // показываем следующий шаг
                            var values = _this20.dateSelect.values;
                            _this20.values.selectedDate = values.selectedDate;
                            _this20.values.isSoftDates = values.softDates;

                            var dateRange = _this20.values.dateRange;
                            _this20.setHiddenValue(_this20.hiddenElemNames.dateFrom, _this20.values.getDateAsValue(dateRange.from));
                            _this20.setHiddenValue(_this20.hiddenElemNames.dateTo, _this20.values.getDateAsValue(dateRange.to));

                            _this20.isChanged.date = isHumanChange;
                            if (_this20.allowAutoOpenNext && isHumanChange && !_this20.isChanged.nightsRange) {
                                setTimeout(function () {
                                    _this20.nightsSelect.show();
                                }, _this20.debounceTime);
                            }

                            _this20._renderDepartDateLabel();
                        },
                        onAfterShow: function onAfterShow() {
                            _this20.refreshDateSelectCalendar();
                        }
                    });

                    // выбранный текст
                    this._renderDepartDateLabel();
                }
            }, {
                key: "initNightsSelect",
                value: function initNightsSelect() {
                    var _this21 = this;

                    this.nightsSelect = new this.components.NightsSelect(this.$main.find('.form_duration'), {
                        onChange: function onChange(isHumanChange) {
                            _this21.values.nightsFrom = _this21.nightsSelect.nightsFrom;
                            _this21.values.nightsTo = _this21.nightsSelect.nightsTo;

                            _this21.setHiddenValue(_this21.hiddenElemNames.nightsFrom, _this21.values.nightsFrom);
                            _this21.setHiddenValue(_this21.hiddenElemNames.nightsTo, _this21.values.nightsTo);

                            if (isHumanChange) {
                                _this21.isChanged.nightsRange = true;
                                if (_this21.nightsSelect.allowAutoCloseOnChange) {
                                    _this21.nightsSelect.hide();
                                    // открываем выбор кол-во человек
                                    // открываем с задержкой, что автоматически dropdown
                                    // не закрылся сразу после открытия из за клик по body
                                    // за пределами самого dropdown
                                    setTimeout(function () {
                                        if (_this21.values.selectedHotel) {
                                            if (_this21.allowAutoOpenNext && !_this21.isChanged.tourists) {
                                                _this21.touristsSelect.show();
                                            }
                                        } else {
                                            if (_this21.allowAutoOpenNext && !_this21.isChanged.stars) {
                                                _this21.starsSelect.show();
                                            }
                                        }
                                    }, _this21.debounceTime);
                                }
                            } else {
                                if (_this21.isChanged.nightsRange) {
                                    // если пользователь уже выбирал ночи, то показываем уведомление
                                    _this21.showTooltip(_this21.nightsSelect.$dropdown, _this21.messages.noDirectionNights, 3500);
                                }
                            }

                            _this21._renderNightsLabel();
                        },
                        onHide: function onHide() {
                            _this21._renderNightsLabel();
                        },
                        values: this._getNightsRangeCurrentValues()
                    });
                    this._renderNightsLabel();
                }
            }, {
                key: "initStarsSelect",
                value: function initStarsSelect() {
                    var _this22 = this;

                    this.starsSelect = new this.components.SearchFormDropdownMultiple({
                        $dropdown: this.$main.find('.form_stars'),
                        dropdownLabelSelector: '.form-title .stars_field',
                        getCustomLabel: function getCustomLabel() {
                            return _this22._getStarsLabel();
                        },
                        onChange: function onChange(isHumanChange) {
                            if (isHumanChange) {
                                _this22.isChanged.stars = true;
                            }
                            _this22.values.setStarsList(_this22.starsSelect.selectedValues);
                            _this22.setHiddenValue(_this22.hiddenElemNames.stars, _this22.values.starsList.join(','));
                        }
                    });

                    var DropdownItem = this.components.SearchFormDropdownItem;

                    var items = [];
                    [STARS_ANY, 5, 4, 3, 2, 1].forEach(function (value) {
                        var label = value === STARS_ANY ? _this22.messages.starsAny : value + ' ' + _this22.messages.pluralizeStars(value);
                        items.push(new DropdownItem({
                            value: value,
                            label: label,
                            selectAll: value === STARS_ANY
                        }));
                    });

                    /**
                     * Список формируется на backend
                     * Лейбл рисуется внутри, в setValue
                     */
                    this.starsSelect.init(this.values.starsList, items);
                }
            }, {
                key: "initTouristsSelect",
                value: function initTouristsSelect() {
                    var _this23 = this;

                    this.touristsSelect = new this.components.TouristsSelect(this.$main.find('.form_tourists'), {
                        onChange: function onChange(isHumanChange) {
                            if (!_this23.touristsSelect) {
                                // При инициализации trigger onChange в Counter на кой-то. Игнорим
                                return;
                            }
                            if (isHumanChange) {
                                _this23.isChanged.tourists = true;
                            }
                            var values = _this23.touristsSelect.values;
                            _this23.values.adult = values.adult;
                            _this23.values.child = values.child;
                            _this23.values.childAges = values.childAges;

                            _this23.setHiddenValue(_this23.hiddenElemNames.adults, _this23.values.adult);
                            _this23.setHiddenValue(_this23.hiddenElemNames.children, _this23.values.child);
                            _this23.setHiddenValue(_this23.hiddenElemNames.ages, _this23.values.childAges.join(','));

                            _this23._renderTouristsLabel();
                        },
                        values: this.values
                    });

                    this._renderTouristsLabel();
                }
            }, {
                key: "updateNightsRange",
                value: function updateNightsRange() {
                    var values = this._getNightsRangeCurrentValues();
                    this.nightsSelect.setValues(values.nightsFrom, values.nightsTo, values.availableNights);
                }
            }, {
                key: "_getNightsRangeCurrentValues",
                value: function _getNightsRangeCurrentValues() {
                    // let nights = [];
                    // if (this.values.countryId) {
                    //     nights = this.data.getDirectionNights(this.values.departCityId, this.values.countryId);
                    // }
                    return {
                        nightsFrom: this.values.nightsFrom,
                        nightsTo: this.values.nightsTo,
                        availableNights: []
                    };
                }
            }, {
                key: "_renderDepartDateLabel",
                value: function _renderDepartDateLabel() {
                    this.dateSelect.updateLabel(this.getDepartDateLabel(true));
                    this._updateNightsSelectTip();
                }
            }, {
                key: "_renderTouristsLabel",
                value: function _renderTouristsLabel() {
                    var _values = this.values,
                        adult = _values.adult,
                        child = _values.child;

                    var touristsText = adult + ' ' + i18nPlural(adult, this.messages.pluralAdults);
                    if (this.values.child > 0) {
                        touristsText += ', ' + child + ' ' + i18nPlural(child, this.messages.pluralChild);
                    }
                    this.touristsSelect.updateLabel(touristsText);
                }
            }, {
                key: "_getStarsLabel",
                value: function _getStarsLabel() {
                    if (this.values.starsList.length === 0) {
                        return this.messages.starsAny.toLocaleLowerCase();
                    }
                    var maxStars = this.values.starsList[this.values.starsList.length - 1];

                    return this.values.starsList.join(',') + ' ' + this.messages.pluralizeStars(maxStars);
                }
            }, {
                key: "_renderNightsLabel",
                value: function _renderNightsLabel() {
                    this.nightsSelect.$label.html(this.getNightsLabel());
                    this._updateNightsSelectTip();
                }
            }, {
                key: "_updateNightsSelectTip",
                value: function _updateNightsSelectTip() {
                    this.nightsSelect.updateSelectionTip(this.messages.datesSelected + ' <b>' + this.getDepartDateLabel() + '</b> ' + this.getNightsLabel());
                }

                /**
                 * После изменения города вылета или страны - обновить связанные данные
                 * @private
                 */

            }, {
                key: "_onAfterDirectionChange",
                value: function _onAfterDirectionChange() {
                    // Обновить доступные ночи
                    this.updateNightsRange();
                    // Обновить календарь
                    this.refreshDateSelectCalendar();
                }

                /**
                 * TODO: check. Возможно дергается чаще чем нужно
                 */

            }, {
                key: "refreshDateSelectCalendar",
                value: function refreshDateSelectCalendar() {
                    var _this24 = this;

                    var isSetDates = true;
                    var dates = [];

                    var newDate = null;
                    if (this.values.countryId) {
                        var departCityId = this.values.departCityId;
                        var countryId = this.values.countryId;

                        if (this.data.isDatesLoaded(departCityId, countryId)) {
                            dates = this.data.getDates(departCityId, countryId);
                            if (dates.length && dates.indexOf(this.values.getSelectedDateAsValue()) === -1) {
                                if (this.isChanged.date) {
                                    // показываем тултип что на эту дату нет вылетов
                                    this.showTooltip(this.dateSelect.$dropdown, this.messages.noDateFlights, 3500);
                                }
                                newDate = moment(dates[0], MOMENT_DATE_FORMAT).toDate();
                                // не тригерит onChange! Нужно устанавливать до setAvailableDates
                                // Визуальное отображение изменяется только в связке с setAvailableDates
                                this.dateSelect.setDate(newDate);
                            }
                        } else {
                            this.data.loadDates(departCityId, countryId, function () {
                                _this24.refreshDateSelectCalendar();
                            });
                            isSetDates = false;
                        }
                    }

                    if (isSetDates) {
                        // Устанавливает доп поля и перерисовывает календарь
                        this.dateSelect.setAvailableDates(dates);
                    }
                    if (newDate !== null) {
                        this.dateSelect.dispatchOnChange(false);
                    }
                }

                /**
                 * @param {jQuery} $dropdown
                 * @param {string} message
                 * @param {number} timeout
                 */

            }, {
                key: "showTooltip",
                value: function showTooltip($dropdown, message) {
                    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3500;

                    var $face = $dropdown.find('.form-title');
                    var placement = this.$main.hasClass('fixed') ? 'bottom' : 'top';
                    $face.bootstrapTooltip({
                        trigger: 'manual',
                        placement: placement,
                        title: message
                    }).bootstrapTooltip('show');
                    setTimeout(function () {
                        $face.bootstrapTooltip('hide');
                    }, timeout);
                }

                /**
                 * @param {string} fieldId
                 * @param {*} value
                 */

            }, {
                key: "setHiddenValue",
                value: function setHiddenValue(fieldId, value) {
                    $('#' + fieldId).val(value);
                }

                /**
                 * TODO: FormValidator
                 * Валидация параметров
                 * @returns {boolean}
                 */

            }, {
                key: "validateForm",
                value: function validateForm() {
                    var isCorrect = true;
                    // проверяем заполено ли поле куда ехать
                    if (!this.values.countryId) {
                        isCorrect = false;

                        this.showTooltip(this.destinationSelect.$dropdown, this.messages.noCountry, 2500);
                    }

                    // проверяем заполнен ли возраст
                    if (this.values.child > 0 && this.values.childAges.length < this.values.child) {
                        isCorrect = false;

                        var bounds = this.touristsSelect.bounds.childrenAges;
                        this.showTooltip(this.touristsSelect.$dropdown, i18nTemplate(this.messages.invalidAge, {
                            min: bounds.min,
                            max: bounds.max
                        }), 2500);
                    }

                    return isCorrect;
                }

                /**
                 * @returns {boolean}
                 */

            }, {
                key: "onSubmit",
                value: function onSubmit() {
                    if (!this.validateForm()) {
                        console.log('submit fail');
                        return false;
                    }
                    console.log('submit success');
                    return true;
                }

                /**
                 * @return {SearchFormValues}
                 */

            }, {
                key: "getValues",
                value: function getValues() {
                    return this.values;
                }

                /** --------------------------------------------------------------------------------------- LABELS START */
                /** TODO: refactor */

            }, {
                key: "getNightsLabel",
                value: function getNightsLabel() {
                    var nightsText = '';
                    var nightsFrom = this.values.nightsFrom;
                    var nightsTo = this.values.nightsTo;
                    if (nightsFrom === nightsTo) {
                        if (this.nightsSelect.isOpenedNow()) {
                            nightsText = i18nTemplate(this.messages.labelNightsRange, {
                                nightsFrom: nightsFrom,
                                nightsTo: '??',
                                label: this.messages.pluralizeNights(5)
                            });
                        } else {
                            nightsText = i18nTemplate(this.messages.labelNights, {
                                nights: nightsTo,
                                label: this.messages.pluralizeNights(nightsTo)
                            });
                        }
                    } else {
                        nightsText = i18nTemplate(this.messages.labelNightsRange, {
                            nightsFrom: nightsFrom,
                            nightsTo: nightsTo,
                            label: this.messages.pluralizeNights(nightsTo)
                        });
                    }

                    return nightsText;
                }

                /**
                 *
                 * @param withAccent {boolean}
                 * @returns {*}
                 */

            }, {
                key: "getDepartDateLabel",
                value: function getDepartDateLabel() {
                    var withAccent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    var selectedDate = this.values.getSelectedDateAsValue();
                    var dateFormat = this.values.isSoftDates ? 'D MMM' : 'D MMMM';
                    var dateText = new window.moment(selectedDate, MOMENT_DATE_FORMAT).format(dateFormat);
                    if (this.values.isSoftDates) {
                        if (withAccent) {
                            dateText += ' ' + '<span class="deviation">' + this.messages.labelDateDiff + '</span>';
                        } else {
                            dateText += ' ' + this.messages.labelDateDiff;
                        }
                    }

                    return dateText;
                }

                /** --------------------------------------------------------------------------------------- LABELS END */

                /** ------------------------ SEARCH START */

            }, {
                key: "dispatchStartNewSearchEvent",
                value: function dispatchStartNewSearchEvent() {
                    var customFormParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    var formParams = customFormParams !== null ? customFormParams.getSearchQuery() : this.values.getSearchQuery();

                    var city = this.data.cities[formParams.departCity];
                    var country = this.data.countries[formParams.country];
                    var searchEvent = new CustomEvent('startNewSearch', {
                        detail: {
                            formParams: formParams,
                            country: {
                                // name: country.name,
                                name2: country.nameTo
                                // to: country.to,
                                // sort: 0,
                                // departs: [],
                            },
                            departCity: {
                                // name: city.name,
                                name2: city.nameFrom
                            }
                        }
                    });
                    window.dispatchEvent(searchEvent);
                    this.trackStartNewSearch();
                }
            }, {
                key: "bindSearchEventsSubscribes",
                value: function bindSearchEventsSubscribes() {
                    var _this25 = this;

                    window.addEventListener('searchByHotel', function (event) {
                        var hotel = event.detail.hotel;

                        _this25.values.resetDestination();
                        _this25.values.countryId = hotel.countryId;
                        _this25.values.setSelectedHotel(hotel.id, hotel.name, hotel.countryId);

                        _this25.destinationSelect.setValues(_this25.values);
                        _this25._onDestinationChange();

                        // Начинаем поиск
                        _this25.triggerFormSubmit();
                    });

                    window.addEventListener('repeatSearch', function () {
                        _this25.triggerFormSubmit();
                    });

                    // Подписка на клик по дате в календаре цен на отель
                    window.addEventListener('hotelPriceCalendar:selectDate', function (event) {
                        var _event$detail = event.detail,
                            nightsFrom = _event$detail.nightsFrom,
                            nightsTo = _event$detail.nightsTo,
                            date = _event$detail.date;


                        var values = Object.assign({}, _this25.values);
                        values.nightsFrom = nightsFrom;
                        values.nightsTo = nightsTo;
                        values.isSoftDates = false;
                        values.selectedDate = moment(date).format('DD.MM.YYYY');

                        var formParams = new SearchFormValues(values);
                        _this25.dispatchStartNewSearchEvent(formParams);
                    });
                }
            }, {
                key: "triggerFormSubmit",
                value: function triggerFormSubmit() {
                    this.$form.submit();
                }
                /** ------------------------ SEARCH END */

                // log search description. Translation is not required!

            }, {
                key: "trackStartNewSearch",
                value: function trackStartNewSearch() {
                    var values = this.values;

                    var touristsLabel = values.adult + ' взр.' + (values.child ? values.child + ' дет. (' + values.childAges.join(',') + ')' : '');

                    var description = "" + this.data.getCity(values.departCityId).name + '-' + ("" + this.destinationSelect.getLabel(true)) + (" c " + values.dateRangeLabel + " (" + this.getNightsLabel() + ")") + (", " + touristsLabel) + (values.stars ? ", \u0437\u0432\u0435\u0437\u0434\u043D\u043E\u0441\u0442\u044C: " + values.stars : '');

                    if (window.userActivity) {
                        var $form = this.$form;
                        var href = $form.prop('action') + '?' + $form.serialize();
                        window.userActivity.saveSearch(href, 'Поиск: ' + description);
                    }
                }
            }, {
                key: "i18n",
                get: function get() {
                    return window.utils.i18n;
                }
            }, {
                key: "components",
                get: function get() {
                    return window.findFormComponents;
                }
            }, {
                key: "$form",
                get: function get() {
                    return $('#find-tours-form', this.$main);
                }
            }]);

            return WideSearchForm;
        }();

        window.WideSearchForm = WideSearchForm;
    }, { "../../../../../include/_js/I18nJsMessages": 4, "../../include/SearchFormData": 2, "../../include/SearchFormValues": 3 }], 2: [function (require, module, exports) {
        var BaseSearchFormData = require('../../../../include/find-form/_js/BaseSearchFormData');

        var SearchFormData = function (_BaseSearchFormData) {
            _inherits(SearchFormData, _BaseSearchFormData);

            function SearchFormData(data) {
                _classCallCheck(this, SearchFormData);

                return _possibleConstructorReturn(this, (SearchFormData.__proto__ || Object.getPrototypeOf(SearchFormData)).call(this, data));
            }

            return SearchFormData;
        }(BaseSearchFormData);

        module.exports = SearchFormData;
    }, { "../../../../include/find-form/_js/BaseSearchFormData": 5 }], 3: [function (require, module, exports) {
        var _require2 = require('../../../../include/find-form/_js/BaseSearchFormValues'),
            BaseSearchFormValues = _require2.BaseSearchFormValues,
            STARS_ANY = _require2.STARS_ANY,
            MOMENT_DATE_FORMAT = _require2.MOMENT_DATE_FORMAT;

        var SearchFormValues = function (_BaseSearchFormValues) {
            _inherits(SearchFormValues, _BaseSearchFormValues);

            function SearchFormValues(values) {
                _classCallCheck(this, SearchFormValues);

                return _possibleConstructorReturn(this, (SearchFormValues.__proto__ || Object.getPrototypeOf(SearchFormValues)).call(this, values));
            }

            _createClass(SearchFormValues, [{
                key: "getSelectedDateAsValue",
                value: function getSelectedDateAsValue() {
                    return this.getDateAsValue(this.selectedDate);
                }

                /**
                 * @return {string}
                 */

            }, {
                key: "makeDateLabel",


                /**
                 * @private
                 * @param {Date} jsDate
                 * @return {string}
                 */
                value: function makeDateLabel(jsDate) {
                    var day = ('0' + jsDate.getDate()).slice(-2);
                    var month = ('0' + (jsDate.getMonth() + 1)).slice(-2);

                    return day + '.' + month;
                }
            }, {
                key: "dateRangeLabel",
                get: function get() {
                    if (this.isSoftDates) {
                        var dateRange = this.dateRange;
                        return this.makeDateLabel(dateRange.from) + ' - ' + this.makeDateLabel(dateRange.to);
                    }
                    return this.makeDateLabel(this.selectedDate);
                }
            }]);

            return SearchFormValues;
        }(BaseSearchFormValues);

        module.exports = {
            SearchFormValues: SearchFormValues,
            STARS_ANY: STARS_ANY,
            MOMENT_DATE_FORMAT: MOMENT_DATE_FORMAT
        };
    }, { "../../../../include/find-form/_js/BaseSearchFormValues": 6 }], 4: [function (require, module, exports) {
        /**
         * Сообщения с backend.
         * Реализует только загрузку сообщений.
         * НЕ РАСШИРЯТЬ! При добавлении чего-либо согласуйте!
         */
        var I18nJsMessages = function I18nJsMessages(props) {
            _classCallCheck(this, I18nJsMessages);

            for (var i in props) {
                if (props[i]) {
                    this[i] = props[i];
                }
            }
        };

        module.exports = I18nJsMessages;
    }, {}], 5: [function (require, module, exports) {
        /**
         * @property {number} id
         * @property {string} name
         * @property {string} nameFrom
         * @property {number|null} altId - Альтернативный город вылета
         */
        var SearchFormDataCity = function SearchFormDataCity(cityId, props) {
            _classCallCheck(this, SearchFormDataCity);

            this.id = cityId;
            this.name = props.name;
            this.nameFrom = props.nameFrom;
            this.altId = props.altId;
        };

        var BaseSearchFormData = function () {
            /**
             * @param {{
             *  urls: {},
             *  cities?: {},
             *  countries?: {},
             *  regions?: {},
             *  directions?: {},
             * }} data
             */
            function BaseSearchFormData(data) {
                _classCallCheck(this, BaseSearchFormData);

                this.urls = {
                    getData: data.urls.getData,
                    getRegions: data.urls.getRegions,
                    getDestinations: data.urls.getDestinations, //query=qwe&country_id=2
                    getDates: data.urls.getDates
                };

                this.isLoaded = {
                    data: false,
                    nonPopularRegions: false
                };

                this.loading = {
                    data: {
                        /** @type {boolean} */
                        started: false,
                        /** @type {Function|null} */
                        onLoad: null
                    },
                    nonPopularRegions: {
                        /** @type {boolean} */
                        started: false,
                        /** @type {Function|null} */
                        onLoad: null
                    }
                };

                this.cities = data.cities || {};
                this.countries = data.countries || {};
                this.regions = data.regions || {};
                this.directions = data.directions || {};

                if (data.directions) {
                    this.isLoaded.data = true;
                    this.isLoaded.nonPopularRegions = true;
                }

                this.availableDates = {};

                /**
                 * @type {{list: *|Array, listByName: null|{}}}
                 */
                this.meals = {
                    list: data.meals || [],
                    listByName: {}
                };

                this.timers = {
                    /** @type {object|null} */
                    getDestinationsRequest: null,
                    /** @type {number} */
                    getHotelsCall: 0
                };
            }

            /**
             * @param {Array} mealNames
             */


            _createClass(BaseSearchFormData, [{
                key: "getMealsIdByName",
                value: function getMealsIdByName(mealNames) {
                    if (jQuery.isEmptyObject(this.meals.listByName)) {
                        for (var i = 0; i < this.meals.list.length; i++) {
                            this.meals.listByName[this.meals.list[i].name] = Number(this.meals.list[i].id);
                        }
                    }
                    var mealId = [];
                    for (var _i3 = 0; _i3 < mealNames.length; _i3++) {
                        if (this.meals.listByName.hasOwnProperty(mealNames[_i3])) {
                            mealId.push(this.meals.listByName[mealNames[_i3]]);
                        }
                    }

                    return mealId;
                }

                /**
                 * @param {Function} onLoad
                 * @param {number|null} countryId
                 */

            }, {
                key: "load",
                value: function load(onLoad) {
                    var _this28 = this;

                    var countryId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    if (this.isLoaded.data) {
                        onLoad();
                    } else {
                        this.loading.data.onLoad = onLoad;
                        this.loading.nonPopularRegions.started = true;
                        if (this.loading.data.started !== true) {
                            this.loading.data.started = true;
                            var url = this.urls.getData;
                            if (countryId) {
                                url += '?countryId=' + encodeURIComponent(countryId);
                            }

                            $.getJSON(url, {}, function (data) {
                                _this28.cities = data.cities;
                                _this28.countries = data.countries;
                                _this28.directions = data.directions;
                                _this28.meals.list = data.meals;
                                _this28.regions = data.regions;

                                _this28.isLoaded.data = true;
                                _this28.isLoaded.nonPopularRegions = true;

                                // last call callback
                                _this28.loading.data.onLoad();
                                if (typeof _this28.loading.nonPopularRegions.onLoad === 'function') {
                                    _this28.loading.nonPopularRegions.onLoad();
                                }
                            });
                        }
                    }
                }

                /**
                 * @deprecated
                 * @param {Function} [callback]
                 */

            }, {
                key: "loadRegions",
                value: function loadRegions(callback) {
                    var _this29 = this;

                    return;
                    if (this.isLoaded.nonPopularRegions) {
                        if (typeof callback === 'function') {
                            callback();
                        }
                    } else {
                        this.loading.nonPopularRegions.onLoad = callback || null;
                        if (this.loading.nonPopularRegions.started !== true) {
                            this.loading.nonPopularRegions.started = true;
                            $.getJSON(this.urls.getRegions, {}, function (regionsByCountry) {
                                _this29._addRegions(regionsByCountry);
                                _this29.isLoaded.nonPopularRegions = true;
                                if (typeof _this29.loading.nonPopularRegions.onLoad === 'function') {
                                    _this29.loading.nonPopularRegions.onLoad();
                                }
                            });
                        }
                    }
                }

                /**
                 * @param {{}|null} regionsByCountry
                 * @private
                 */

            }, {
                key: "_addRegions",
                value: function _addRegions(regionsByCountry) {
                    if (!regionsByCountry) {
                        return;
                    }
                    var countryId = void 0;
                    for (countryId in regionsByCountry) {
                        if (!regionsByCountry.hasOwnProperty(countryId)) {
                            continue;
                        }
                        // extends already loaded popular countries regions
                        this.regions[countryId] = regionsByCountry[countryId];
                    }
                }

                /**
                 * return {[{ id: number, name: string, nameFrom: string, sort: number }]}
                 */

            }, {
                key: "getSortedCities",
                value: function getSortedCities() {
                    var sortedCities = [];
                    var city = void 0;
                    for (var cityId in this.cities) {
                        if (!this.cities.hasOwnProperty(cityId)) {
                            continue;
                        }
                        city = this.cities[cityId];
                        sortedCities.push({
                            id: cityId,
                            name: city.name,
                            nameFrom: city.nameFrom,
                            sort: city.sort
                        });
                    }

                    return sortedCities.sort(function (a, b) {
                        return a.sort - b.sort;
                    });
                }

                /**
                 *
                 * @param {number[]} departCitiesId
                 * @param {number} preferDepartCityId - город, который должен быть в начале
                 */

            }, {
                key: "getSortedCountryDepartCities",
                value: function getSortedCountryDepartCities(departCitiesId, preferDepartCityId) {
                    departCitiesId.sort(function (a, b) {
                        if (b === preferDepartCityId) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });

                    return departCitiesId;
                }

                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @return {boolean}
                 */

            }, {
                key: "isDatesLoaded",
                value: function isDatesLoaded(cityId, countryId) {
                    return cityId in this.availableDates && countryId in this.availableDates[cityId];
                }

                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @param {Function} onLoad
                 */

            }, {
                key: "loadDates",
                value: function loadDates(cityId, countryId, onLoad) {
                    var _this30 = this;

                    $.getJSON(this.urls.getDates, {
                        depart_city_id: cityId,
                        country_id: countryId
                    }, function (data) {
                        if (!_this30.availableDates.hasOwnProperty(data.depart_city_id)) {
                            _this30.availableDates[data.depart_city_id] = {};
                        }
                        _this30.availableDates[data.depart_city_id][data.country_id] = data.dates;
                        onLoad();
                    }).fail(function () {
                        onLoad();
                    });
                }
            }, {
                key: "getDates",


                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @return {Array}
                 */
                value: function getDates(cityId, countryId) {
                    return this.isDatesLoaded(cityId, countryId) ? this.availableDates[cityId][countryId] : [];
                }

                /**
                 * @param {number} cityId
                 * @param {number|null} alternativeCityId
                 * @return {{other: Array, popular: Array, alternative: Array}}
                 */

            }, {
                key: "getSortedSplitDirections",
                value: function getSortedSplitDirections(cityId) {
                    var alternativeCityId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    var sortedDirections = this.getSortedDirections(cityId);
                    return {
                        popular: sortedDirections.slice(0, 6),
                        other: sortedDirections.slice(6), // TODO: sorted by name
                        alternative: alternativeCityId === null ? []
                        // TODO: Полотнищем может быть неудобно (Sort by name | split | ...)
                        : this.getSortedDirections(alternativeCityId)
                    };
                }

                /**
                 * Возвращает направления
                 * @param {number} skipDepartCityId
                 * @return {Array}
                 */

            }, {
                key: "getOtherSortedDirections",
                value: function getOtherSortedDirections(skipDepartCityId) {
                    var sortedOtherDirections = [];
                    for (var departCityId in this.directions) {
                        if (!this.directions.hasOwnProperty(departCityId)) {
                            continue;
                        }
                        departCityId = parseInt(departCityId, 10);
                        if (Number(departCityId) === skipDepartCityId) {
                            continue;
                        }
                        var directions = this.getCityDirections(departCityId);
                        sortedOtherDirections = sortedOtherDirections.concat(this._prepareCityDirectionsForSort(departCityId, directions));
                    }

                    return BaseSearchFormData._sortDirections(sortedOtherDirections);
                }

                /**
                 * @param {number} cityId
                 * return {[]}
                 */

            }, {
                key: "getSortedDirections",
                value: function getSortedDirections(cityId) {
                    var directions = this.getCityDirections(cityId);
                    return BaseSearchFormData._sortDirections(this._prepareCityDirectionsForSort(cityId, directions));
                }

                /**
                 * @param {number} cityId
                 * @param {{}} cityDirections
                 * @return {Array}
                 * @private
                 */

            }, {
                key: "_prepareCityDirectionsForSort",
                value: function _prepareCityDirectionsForSort(cityId, cityDirections) {
                    var direction = void 0;
                    var countryId = void 0;

                    var sortedDirections = [];
                    for (countryId in cityDirections) {
                        if (!cityDirections.hasOwnProperty(countryId)) {
                            continue;
                        }
                        direction = cityDirections[countryId];
                        sortedDirections.push({
                            departCity: {
                                id: cityId
                            },
                            country: {
                                id: parseInt(countryId, 10),
                                name: this.countries[countryId].name,
                                code: this.countries[countryId].code
                            },
                            sort: this.countries[countryId].sort,
                            price: direction.price || 0,
                            currency: direction.cur || ''
                        });
                    }

                    return sortedDirections;
                }
            }, {
                key: "getCityDirections",


                /**
                 * @param {number} cityId
                 * @return {*|{}}
                 */
                value: function getCityDirections(cityId) {
                    return this.directions[cityId] || {};
                }

                /**
                 *
                 * @returns {null|number}
                 */

            }, {
                key: "getFirstCityId",
                value: function getFirstCityId() {
                    for (var cityId in this.cities) {
                        if (this.cities.hasOwnProperty(cityId)) {
                            return Number(cityId);
                        }
                    }

                    return null;
                }

                /**
                 * @param {number} cityId
                 * @return {boolean}
                 */

            }, {
                key: "isCityExists",
                value: function isCityExists(cityId) {
                    return cityId in this.cities;
                }

                /**
                 * @param {number} cityId
                 * @return {SearchFormDataCity|null}
                 */

            }, {
                key: "getCity",
                value: function getCity(cityId) {
                    return this.isCityExists(cityId) ? new SearchFormDataCity(cityId, this.cities[cityId]) : null;
                }

                /**
                 * @param {number} countryId
                 * @return {boolean}
                 */

            }, {
                key: "isCountryExists",
                value: function isCountryExists(countryId) {
                    return countryId in this.countries;
                }

                /**
                 * @param {number} countryId
                 * @return {{name: string, sort: number, departCitiesId: Array}}
                 */

            }, {
                key: "getCountry",
                value: function getCountry(countryId) {
                    var country = this.isCountryExists(countryId) ? this.countries[countryId] : null;
                    return {
                        name: country ? country.name : 'N/A',
                        nameTo: country ? country.nameTo : 'N/A',
                        to: country ? country.to : 'в',
                        sort: country ? country.sort : 0,
                        departCitiesId: country ? country.departs : []
                    };
                }

                /**
                 * @param {number} countryId
                 * @param {number} regionId
                 * @return {boolean}
                 */

            }, {
                key: "isRegionExists",
                value: function isRegionExists(countryId, regionId) {
                    return this.regions.hasOwnProperty(countryId) && this.regions[countryId].hasOwnProperty(regionId);
                }

                /**
                 * @param {number} countryId
                 * @param {number} regionId
                 * @return {string}
                 */

            }, {
                key: "getRegionName",
                value: function getRegionName(countryId, regionId) {
                    var regionName = '';
                    if (this.isRegionExists(countryId, regionId)) {
                        regionName = this.regions[countryId][regionId].name;
                    }

                    return regionName;
                }

                /**
                 * @param {number} countryId
                 * @param {number[]} regionIds
                 * @return {string}
                 */

            }, {
                key: "getRegionNames",
                value: function getRegionNames(countryId, regionIds) {
                    var _this31 = this;

                    return regionIds.map(function (regionId) {
                        return _this31.getRegionName(countryId, regionId);
                    }).join(', ');
                }

                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @return {{value: number, currency: string}}
                 */

            }, {
                key: "getDirectionPrice",
                value: function getDirectionPrice(cityId, countryId) {
                    var haveDirection = this.isDirectionAvailable(cityId, countryId);
                    return {
                        value: haveDirection ? this.directions[cityId][countryId]['price'] : 0,
                        currency: haveDirection ? this.directions[cityId][countryId]['cur'] : ''
                    };
                }

                /**
                 * @param {number} countryId
                 * @param {number} cityId
                 */

            }, {
                key: "isCountryDirectionAvailable",
                value: function isCountryDirectionAvailable(countryId, cityId) {
                    return this.countries[countryId].departs.indexOf(cityId) !== -1;
                }

                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @return boolean
                 */

            }, {
                key: "isDirectionAvailable",
                value: function isDirectionAvailable(cityId, countryId) {
                    return this.directions.hasOwnProperty(cityId) && this.directions[cityId].hasOwnProperty(countryId);
                }

                /**
                 *
                 * @param {number} cityId
                 * @param {number} countryId
                 * @return {Array}
                 */

            }, {
                key: "getDirectionNights",
                value: function getDirectionNights(cityId, countryId) {
                    var nights = [];
                    if (this.isDirectionAvailable(cityId, countryId)) {
                        nights = this.directions[cityId][countryId].nights;
                    }

                    return nights.sort(function (a, b) {
                        return a - b;
                    });
                }

                /**
                 * @param {{}} country - this.countries[id]
                 */
                // sortCountryDeparts(country, cityId) {
                //     const departs = country.departs;
                //     departs.sort(function(a, b) {
                //         return b === cityId ? 1 : 0;
                //     });
                //
                //     return departs;
                // }

            }, {
                key: "abortGetDestinationsRequest",
                value: function abortGetDestinationsRequest() {
                    if (this.timers.getDestinationsRequest) {
                        this.timers.getDestinationsRequest.abort();
                        this.timers.getDestinationsRequest = null;
                    }
                    if (this.timers.getHotelsCall) {
                        clearInterval(this.timers.getHotelsCall);
                    }
                }

                /**
                 * @param {string} slug
                 * @param {Function} callback
                 * @param {number} [countryId]
                 */

            }, {
                key: "getDestinations",
                value: function getDestinations(slug, callback, countryId) {
                    var _this32 = this;

                    this.abortGetDestinationsRequest();
                    var params = {
                        query: slug,
                        limit: 20
                    };
                    if (countryId) {
                        params.countryId = countryId;
                    }
                    this.timers.getHotelsCall = setTimeout(function () {
                        _this32.timers.getDestinationsRequest = $.getJSON(_this32.urls.getDestinations, params, function (data) {
                            callback(data);
                        });
                    }, 100);
                }

                /**
                 * @note Не юзайте в автокомплите. Может лагать из-за GC
                 * @param {number} countryId
                 * @return {Array}
                 */

            }, {
                key: "getSortedRegions",
                value: function getSortedRegions(countryId) {
                    var regions = [];
                    if (countryId in this.regions) {
                        for (var regionId in this.regions[countryId]) {
                            if (this.regions[countryId].hasOwnProperty(regionId)) {
                                regions.push(this.regions[countryId][regionId]);
                            }
                        }
                    }

                    if (regions.length) {
                        regions.sort(function (a, b) {
                            return b.popularity - a.popularity;
                        });
                    }

                    return regions;
                }
            }], [{
                key: "_sortDirections",
                value: function _sortDirections(sortedDirections) {
                    sortedDirections.sort(function (a, b) {
                        return a.sort - b.sort;
                    });
                    return sortedDirections;
                }
            }]);

            return BaseSearchFormData;
        }();

        module.exports = BaseSearchFormData;
    }, {}], 6: [function (require, module, exports) {
        var STARS_ANY = 0;

        var REGIONS_ANY = 0;

        var CITY_DEFAULT = window.app.defaultCity.apiId;

        var MOMENT_DATE_FORMAT = 'DD.MM.YYYY';

        var _require3 = require('./BaseSearchFormValuesHotel'),
            BaseSearchFormValuesHotel = _require3.BaseSearchFormValuesHotel;

        /**
         * @param {string[]|number[]} array
         */


        function arrayToInt(array) {
            var arrayInt = [];
            array.forEach(function (value) {
                arrayInt.push(parseInt(value, 10));
            });
            return arrayInt;
        }
        /**
         * @protected {Date} selectedDate
         * @protected {boolean} isSoftDates
         */

        var BaseSearchFormValues = function () {
            /**
             * @param {{}} values
             */
            function BaseSearchFormValues(values) {
                _classCallCheck(this, BaseSearchFormValues);

                this.departCityId = parseInt(values.departCityId, 10);
                this.countryId = parseInt(values.countryId, 10) || 0;

                /** @type {number[]} */
                this.regionIds = [];
                if (values.regionIds.length) {
                    this.setRegionIds(values.regionIds);
                }

                /** @type {BaseSearchFormValuesHotel|null} */
                this.selectedHotel = values.selectedHotel ? new BaseSearchFormValuesHotel(values.selectedHotel) : null;

                var date = values.selectedDate.split('.');

                /** @type {Date|string} */
                this.selectedDate = new Date(date[2], date[1] - 1, date[0]);
                /**
                 * Гибкий поиск +- 3дня
                 * @type {boolean}
                 */
                this.isSoftDates = !!values.isSoftDates;
                this.rangeDays = 3;

                this.nightsFrom = parseInt(values.nightsFrom, 10);
                this.nightsTo = parseInt(values.nightsTo, 10);
                this.adult = parseInt(values.adult, 10);
                this.child = parseInt(values.child, 10);
                /** @type {Array} */
                this.childAges = values.childAges;

                /** @type {number} */
                this.stars = values.stars === STARS_ANY ? STARS_ANY : parseInt(values.stars, 10);

                /** @type {number[]} */
                this.starsList = [];
                if (values.starsList.length) {
                    this.setStarsList(values.starsList);
                }

                /** @type {number[]} */
                this.mealIds = values.mealIds;

                /** @type {boolean} */
                this.search = !!values.search;

                /** @type {number} - 0|1|2 */
                this.combined = values.combined;

                /** @type {boolean} - 0|1 */
                this.emitSearchParams = !!values.emitSearchParams;
            }

            _createClass(BaseSearchFormValues, [{
                key: "setSelectedHotel",


                /**
                 * @param {number} hotelId
                 * @param {string} hotelName
                 * @param {number} countryId
                 */
                value: function setSelectedHotel(hotelId, hotelName, countryId) {
                    this.selectedHotel = new BaseSearchFormValuesHotel({
                        id: Number(hotelId),
                        name: hotelName,
                        countryId: Number(countryId)
                    });
                }
            }, {
                key: "resetHotel",
                value: function resetHotel() {
                    this.selectedHotel = null;
                }

                /**
                 * предпочитаемый город вылета по умолчанию, тоже может быть недоступен
                 * @returns {*}
                 */

            }, {
                key: "getDefaultDepartCityId",
                value: function getDefaultDepartCityId() {
                    return CITY_DEFAULT;
                }
            }, {
                key: "resetDestination",
                value: function resetDestination() {
                    this.countryId = 0;
                    this.regionIds = [];
                    this.resetHotel();
                }

                /**
                 * @param {Date} date
                 * @param {string|null} format
                 * @return {string}
                 */

            }, {
                key: "getDateAsValue",
                value: function getDateAsValue(date) {
                    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);
                    if (format === 'YYYY-MM-DD') {
                        return date.getFullYear() + "-" + month + "-" + day;
                    }
                    return day + '.' + month + '.' + date.getFullYear(); // MOMENT_DATE_FORMAT
                }
            }, {
                key: "getSelectedHotelsId",
                value: function getSelectedHotelsId() {
                    var hotelIds = [];
                    if (this.selectedHotel) {
                        hotelIds.push(this.selectedHotel.id);
                    }

                    return hotelIds;
                }

                /**
                 * @return {window.search.Query}
                 */

            }, {
                key: "getSearchQuery",
                value: function getSearchQuery() {
                    var params = Object.assign({}, this);
                    params.hotelIds = this.getSelectedHotelsId();
                    params.stars = 0; // any
                    params.starsList = this.starsList; // selected stars
                    var dateRange = this.dateRange;
                    params.dateFrom = dateRange.from;
                    params.dateTo = dateRange.to;
                    params.combined = this.combined;
                    if (params.mealIds.length) {
                        params.mealIds = this.mealIds;
                    }
                    if (params.child) {
                        params.childAges = params.childAges.slice(0, this.child);
                    }

                    return new window.search.Query(params);
                }

                /**
                 * Поиск будет начинаться на этой же странице, без перехода
                 * @return {boolean}
                 */

            }, {
                key: "isStartOnCurrentPage",
                value: function isStartOnCurrentPage() {
                    return this.search;
                }

                /**
                 * @param {number[]} regionIds
                 */

            }, {
                key: "setRegionIds",
                value: function setRegionIds(regionIds) {
                    this.regionIds = arrayToInt(regionIds);
                }

                /**
                 * @param {number} stars
                 */

            }, {
                key: "setStars",
                value: function setStars(stars) {
                    this.stars = stars;
                    this.starsList = [];
                }

                /**
                 * @param {string[]|number[]} stars
                 */

            }, {
                key: "setStarsList",
                value: function setStarsList(stars) {
                    this.stars = STARS_ANY;
                    this.starsList = arrayToInt(stars).sort(function (a, b) {
                        return a - b;
                    });
                }
            }, {
                key: "dateRange",
                get: function get() {
                    var date = this.selectedDate.getDate();
                    var rangeDays = this.isSoftDates ? this.rangeDays : 0;
                    var from = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), date - rangeDays);
                    var to = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), date + rangeDays);

                    return { from: from, to: to };
                }
            }]);

            return BaseSearchFormValues;
        }();

        module.exports = {
            BaseSearchFormValues: BaseSearchFormValues,
            STARS_ANY: STARS_ANY,
            MOMENT_DATE_FORMAT: MOMENT_DATE_FORMAT
        };
    }, { "./BaseSearchFormValuesHotel": 7 }], 7: [function (require, module, exports) {
        var BaseSearchFormValuesHotel =
        /**
         * @param {{
         *   id: number,
         *   name: string,
         *   countryId: number
         * }} props
         */
        function BaseSearchFormValuesHotel(props) {
            _classCallCheck(this, BaseSearchFormValuesHotel);

            this.id = props.id;
            this.name = props.name;
            this.countryId = props.countryId;
        };

        module.exports = {
            BaseSearchFormValuesHotel: BaseSearchFormValuesHotel
        };
    }, {}] }, {}, [1]);